// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import apiUrl from "../../Environment/Api";
// import { useNavigate, useParams } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const useForceUpdate = () => {
//   const [, forceUpdate] = useState();
//   return useCallback(() => forceUpdate((prev) => !prev), []);
// };
// function InvoiceUpdate() {
//   const forceUpdate = useForceUpdate();
//   const navigate = useNavigate();
//   const [exchangeRate, setExchangeRate] = useState("");

//   const { invoice_id } = useParams();

//   console.log("edit id", invoice_id);

//   const [invoiceData, setInvoiceDetails] = useState({});

//   const [getclientaddress, setclientaddress] = useState("");
//   const [getclientcountry, setclientcountry] = useState("");
//   const [getclientmobile, setclientmobile] = useState("");
//   const [getclientName, setclientName] = useState("");
//   const [selectedClient, setSelectedClient] = useState("");
//   const [invoicedetailsId, setinvoicedetailsId] = useState("");

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const responseDetails = await axios.get(
//           apiUrl + `/invoicedetails/${invoice_id}`
//         );
//         const invoiceDetails = responseDetails.data[0];
//         console.log("invoice details datas", invoiceDetails);
//         setInvoiceDetails(invoiceDetails);
//         setSelectedClient(invoiceDetails.clientId);
//         setinvoicedetailsId(invoiceDetails.id);
//         setData({
//           invoiceId: invoiceDetails.invoiceId,
//           date: invoiceDetails.date,
//           dueDate: invoiceDetails.dueDate,
//           notes: invoiceDetails.notes,
//           totalTax: invoiceDetails.totalTax,
//           paymentStatus: invoiceDetails.paymentStatus,
//           totalAmount: invoiceDetails.totalAmount,
//           paymentDate: invoiceDetails.paymentDate,
//         });

//         const responseList = await axios.get(
//           apiUrl + `/invoicelist/${invoice_id}`
//         );
//         setTableData(responseList.data);
//         console.log("invoicelist datas", responseList.data);
//         // setTableData(responseList.data.map(item => ({ ...item, id: item.itemId })));
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     };

//     console.log("invoice list table data", tableData);

//     fetchData();
//   }, [invoice_id]);

//   // to get client details ---------------
//   const [ClientDetails, setClientDetails] = useState([]);
//   const clientdetails = async () => {
//     try {
//       const response = await axios.get(apiUrl + "/clientdetails");
//       if (response) {
//         setClientDetails(response.data);
//       }
//     } catch (error) {
//       console.error("Error fetching client details:", error);
//     }
//   };

//   useEffect(() => {
//     clientdetails();
//     categorytype();
//     const fetchExchangeRate = async () => {
//       try {
//         const response = await fetch(
//           "https://api.frankfurter.app/latest?from=USD&to=INR"
//         );
//         const data = await response.json();
//         const usdToInrRate = data.rates.INR;
//         setExchangeRate(usdToInrRate);
//       } catch (error) {
//         console.error("Error fetching exchange rate:", error);
//       }
//     };
//     fetchExchangeRate();
//   }, []);

//   const [currentDate, setCurrentDate] = useState(getFormattedDate());
//   const [tableData, setTableData] = useState([]);
//   const [subtotal, setSubtotal] = useState(0);
//   const [tax, setTax] = useState(0);
//   const [netTotal, setNetTotal] = useState(0);
//   const [clientRowCreated, setClientRowCreated] = useState(false);

//   function filter() {
//     console.log("delected client", selectedClient);
//     const clientaddresscountryfilter = ClientDetails.filter(
//       (data) => data.id === selectedClient
//     );
//     console.log("client detqails", clientaddresscountryfilter);
//     if (clientaddresscountryfilter.length > 0) {
//       setclientName(clientaddresscountryfilter[0].clientName);
//       setclientaddress(clientaddresscountryfilter[0].address);
//       setclientcountry(clientaddresscountryfilter[0].countrycode);
//       setclientmobile(clientaddresscountryfilter[0].mobile);
//     }
//   }
//   useEffect(() => {
//     if (ClientDetails.length > 0) {
//       filter();
//     }
//   }, [ClientDetails]);

//   // const handleClientChange = async (event) => {
//   //     const clientValue = event.target.value;
//   //     setSelectedClient(clientValue);

//   // };

//   const handlerowadd = (e) => {
//     e.preventDefault();
//     console.log("Add row button clicked");
//     console.log("clientRowCreated before:", clientRowCreated);

//     if (!clientRowCreated) {
//       const newId = Date.now();
//       const newDate = getFormattedDate();
//       const newRow = {
//         id: newId,
//         date: newDate,
//         projectName: "",
//         type: "",
//         quantity: 1,
//         price: 0,
//         tax: "",
//         standard: "",
//         premier: "",
//         twilight: "",
//         day_to_dusk: "",
//         vra: "",
//         vr: "",
//         col7: "",
//         col8: "",
//         col9: "",
//         amount: "",
//         rate: "",
//       };
//       setTableData((prevTableData) => [...prevTableData, newRow]);
//       setClientRowCreated(true);
//       console.log("New row added");
//     } else {
//       console.log("A row has already been added");
//     }
//   };

//   const [selectedType, setSelectedType] = useState({});
//   const handleTypeChange = async (index, value) => {
//     if (value !== "") {
//       setTableData((prevTableData) => {
//         const updatedTableData = [...prevTableData];
//         console.log("table change ", updatedTableData);
//         updatedTableData[index].type = value;
//         console.log("table change after ", updatedTableData);

//         const selectedTypeData = getCategoryType.find(
//           (item) => item.type === value
//         );
//         if (selectedTypeData) {
//           updatedTableData[index].price =
//             getclientcountry === "91"
//               ? selectedTypeData.INRprice
//               : selectedTypeData.price;
//         }

//         if (index === updatedTableData.length - 1) {
//           const newId = Date.now();
//           const newRow = {
//             id: newId,
//             date: getFormattedDate(),
//             projectName: "",
//             type: "",
//             quantity: 1,
//             price: 0,
//             tax: "",
//             standard: "",
//             premier: "",
//             twilight: "",
//             day_to_dusk: "",
//             vra: "",
//             vr: "",
//             col7: "",
//             col8: "",
//             col9: "",
//             amount: "",
//             rate: "",
//           };
//           updatedTableData.push(newRow);
//           setClientRowCreated(true);
//         }

//         console.log("After Update:", updatedTableData);

//         // Set selected type directly in the state
//         setSelectedType((prevSelectedType) => {
//           const newSelectedType = { ...prevSelectedType };
//           newSelectedType[index] = value;
//           return newSelectedType;
//         });

//         return updatedTableData;
//       });
//     }
//   };

//   const handleUserInputChange = (index, property, value) => {
//     const updatedTableData = [...tableData];
//     updatedTableData[index][property] = value;
//     setTableData(updatedTableData);
//   };

//   useEffect(() => {
//     let newSubtotal = 0;
//     let newTax = 0;

//     tableData.forEach((item) => {
//       const quantity = parseFloat(item.quantity) || 0;
//       const price = parseFloat(item.price) || 0;
//       const itemSubtotal = quantity * price;
//       const itemTax = ((parseFloat(item.tax) || 0) * itemSubtotal) / 100;

//       newSubtotal += itemSubtotal;
//       newTax += itemTax;
//     });

//     setSubtotal(newSubtotal);
//     setTax(newTax);

//     const newNetTotal = newSubtotal + newTax;
//     setNetTotal(newNetTotal);
//   }, [tableData]);

//   const [deleteids, setDeleteIds] = useState([]);
//   const tablerowdelete = (ItemId) => {
//     setTableData((prevItems) => prevItems.filter((item) => item.id !== ItemId));
//     setDeleteIds((prevIds) => [...prevIds, ItemId]);
//   };
//   console.log("deletedd ids", deleteids);
//   // useEffect(() => {

//   // }, [deleteids]);

//   const handleClearAll = () => {
//     setTableData([]);
//     setClientRowCreated(false);
//   };

//   const handleback = () => {
//     navigate("/invoice");
//   };

//   //category type get
//   const [getCategoryType, setCategoryType] = useState([]);
//   const categorytype = async () => {
//     try {
//       const response = await axios.get(apiUrl + "/category");
//       if (response) {
//         if (!response.length > 0) {
//           setCategoryType(response.data);
//           console.log("category type getted", response.data);
//         }
//       }
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   // get invoice no. ----------------------------

//   // const [getinvoiceno, setinvoiceno] = useState('');

//   // const invoiceno = async () => {
//   //     try {
//   //         const response = await axios.get(apiUrl + '/invoiceno');
//   //         setinvoiceno(response.data.invoiceId);
//   //     } catch (err) {
//   //         console.log(err)
//   //     }
//   // }
//   // get current date---------------------------------------
//   function getFormattedDate() {
//     const today = new Date();
//     const year = today.getFullYear();
//     let month = today.getMonth() + 1;
//     let day = today.getDate();

//     month = month < 10 ? `0${month}` : month;
//     day = day < 10 ? `0${day}` : day;

//     return `${year}-${month}-${day}`;
//   }

//   const validateForm = () => {
//     const emptyFields = [];
//     if (selectedClient === "") {
//       emptyFields.push("Client Name");
//     }
//     if (currentDate === "") {
//       emptyFields.push("Date");
//     }
//     if (getData.dueDate === "") {
//       emptyFields.push("Due Date");
//     }
//     if (tax === "") {
//       emptyFields.push("Tax");
//     }
//     tableData.forEach((item, index) => {
//       if (item.type !== "") {
//         if (item.projectName === "") {
//           emptyFields.push(`Project Name at row ${index + 1}`);
//         }
//         if (item.tax === "") {
//           emptyFields.push(`Tax at row ${index + 1}`);
//         }
//         // if (item.quantity === "") {
//         //   emptyFields.push(`Quantity at row ${index + 1}`);
//         // }
//         // if (item.price === "") {
//         //   emptyFields.push(`Price at row ${index + 1}`);
//         // }
//         // if (item.standard === "") {
//         //   emptyFields.push(`Standard at row ${index + 1}`);
//         // }
//         // if (item.premier === "") {
//         //   emptyFields.push(`Premier at row ${index + 1}`);
//         // }
//         // if (item.twilight === "") {
//         //   emptyFields.push(`Twilight at row ${index + 1}`);
//         // }
//         // if (item.day_to_dusk === "") {
//         //   emptyFields.push(`Day to Dusk at row ${index + 1}`);
//         // }
//         // if (item.vra === "") {
//         //   emptyFields.push(`Vra at row ${index + 1}`);
//         // }
//         // if (item.vr === "") {
//         //   emptyFields.push(`Vr at row ${index + 1}`);
//         // }
//         // if (item.col7 === "") {
//         //   emptyFields.push(`col7 at row ${index + 1}`);
//         // }
//         // if (item.col8 === "") {
//         //   emptyFields.push(`col8 at row ${index + 1}`);
//         // }
//         // if (item.col9 === "") {
//         //   emptyFields.push(`col9 at row ${index + 1}`);
//         // }
//         // if (item.amount === "") {
//         //   emptyFields.push(`Amount at row ${index + 1}`);
//         // }
//         // if (item.rate === "") {
//         //   emptyFields.push(`Rate at row ${index + 1}`);
//         // }
//       }
//     });
//     if (emptyFields.length > 0) {
//       alert(
//         `Please fill in the following required fields: ${emptyFields.join(
//           ", "
//         )}`
//       );
//       return false;
//     }
//     return true;
//   };

//   const [isDataSubmitted, setIsDataSubmitted] = useState(false);
//   // submit data
//   const [getData, setData] = useState({
//     invoiceId: "",
//     clientName: "",
//     date: "",
//     dueDate: "",
//     notes: "",
//     totalTax: "",
//     paymentStatus: "Unpaid",
//     totalAmount: "",
//     paymentDate: "",
//   });

//   const toaster = (callback) => {
//     toast.success("Data submitted successfully!", {
//       autoClose: 1000,
//       hideProgressBar: true,
//       onClose: callback,
//     });
//   };

//   const [invoiceupdateid, setupdateid] = useState([]);
//   // submit data
//   const submitdata = async () => {
//     const isValid = validateForm();
//     if (!isDataSubmitted) {
//       if (isValid) {
//         try {
//           setIsDataSubmitted(true);
//           const updatedTableData = [...tableData];
//           setTableData(updatedTableData);
//           const filteredTableData = updatedTableData.filter(
//             (item) => item.type.trim() !== ""
//           );

//           const newData = {
//             invoiceId: invoice_id,
//             clientName: selectedClient,
//             date: getData.date,
//             dueDate: getData.dueDate,
//             totalAmount: netTotal.toFixed(2),
//             notes: getData.notes,
//             totalTax: tax.toFixed(2),
//             paymentStatus: "Unpaid",
//             paymentDate: "",
//           };
//           const requestData = { ...getData, ...newData };
//           console.log("submit data", requestData);
//           const response = await axios.put(
//             apiUrl + `/invoicedetailsupdate/${invoicedetailsId}`,
//             requestData
//           );
//           console.log(response.data);

//           if (response.data.status === "success") {
//             for (const id of deleteids) {
//               const response = await axios.delete(
//                 apiUrl + `/invoicelist/${id}`
//               );
//               console.log("invoicelist data", response.data);
//               console.log(`Deleting item with ID ${id}`);
//             }
//             setDeleteIds([]);
//             const invoicelistData = filteredTableData.map((data) => ({
//               id: data.id,
//               invoiceId: invoice_id,
//               date: data.date,
//               clientName: selectedClient,
//               projectName: data.projectName,
//               type: data.type,
//               quantity: data.quantity,
//               standard: data.standard,
//               premier: data.premier,
//               twilight: data.twilight,
//               day_to_dusk: data.day_to_dusk,
//               vra: data.vra,
//               vr: data.vr,
//               col7: data.col7,
//               col8: data.col8,
//               col9: data.col9,
//               price: data.price,
//               tax: data.tax,
//               amount:
//                 data.amount !== ""
//                   ? data.amount
//                   : (
//                       parseFloat(data.price) * exchangeRate +
//                       parseFloat((data.price * exchangeRate * data.tax) / 100)
//                     ).toFixed(2),
//               rate:
//                 data.rate !== ""
//                   ? data.rate
//                   : (
//                       parseFloat(data.price) +
//                       parseFloat((data.price * data.tax) / 100)
//                     ).toFixed(2),
//               totalAmount: (
//                 parseFloat(data.quantity) * parseFloat(data.price) +
//                 (parseFloat(data.tax) *
//                   parseFloat(data.quantity) *
//                   parseFloat(data.price)) /
//                   100
//               ).toFixed(2),
//             }));
//             console.log("final data list", invoicelistData);
//             try {
//               const response = await axios.post(
//                 apiUrl + "/invoicelistupdate",
//                 invoicelistData
//               );
//               console.log("invoicelist data", response.data);
//               toaster(() => navigate("/invoice"));
//             } catch (err) {
//               console.log("Error in invoicelist request:", err);
//             }
//           } else {
//             console.log(
//               "Error in invoicedetails response:",
//               response.data.error
//             );
//           }
//         } catch (err) {
//           console.log("Error in submitdata function:", err);
//         }
//       } else {
//         console.log("Data has already been submitted");
//       }
//     }
//   };

//   const handlenavigate = async () => {
//     const isValid = validateForm();
//     await submitdata();
//     if (isValid) {
//       navigate(`/invoice/invoiceprint/${invoice_id}`, {});
//       // try {
//       //     await submitdata();
//       //     navigate('/bill', {
//       //         state: {
//       //             invoiceData: {
//       //                 invoiceId: invoice_id,
//       //                 currentDate,
//       //                 dueDate: getData.dueDate,
//       //                 getclientName,
//       //                 getclientaddress,
//       //                 getclientcountry,
//       //                 getclientmobile,
//       //                 tableData,
//       //                 subtotal,
//       //                 tax: tax.toFixed(2),
//       //                 netTotal,
//       //                 notes: getData.notes,
//       //             }
//       //         }
//       //     });
//       // } catch (error) {
//       //     console.error('Error submitting data and navigating:', error);
//       // }
//     }
//   };

//   console.log("final table data", tableData);

//   return (
//     <>
//       <ToastContainer />
//       <h3 className="text-center">Edit Invoice</h3>
//       <hr />
//       <div className="mx-1">
//         <div className="invoicebackground1">
//           <form className="row">
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <label className="form-label">Invoice No.</label>
//               <input
//                 className="form-control"
//                 value={invoice_id}
//                 type="text"
//               ></input>
//             </div>
//             <div className="col-lg-6 col-md-4"></div>
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <label className="form-label">Date :</label>
//               <input
//                 className="form-control"
//                 type="date"
//                 value={getData.date}
//                 onChange={(e) => {
//                   setData({ ...getData, date: e.target.value });
//                 }}
//                 required
//               />
//             </div>
//           </form>
//         </div>
//         <div className="invoicebackground1">
//           <form className="row">
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <div className="mx-3 dropdown">
//                 <label className="form-label">Client Name :</label>
//                 <div className="position-relative">
//                   <select
//                     className="form-control dropdown-toggle custom-select"
//                     value={selectedClient}
//                   >
//                     <option value="">{getclientName}</option>
//                   </select>
//                   <div className="dropdown-arrow"></div>
//                 </div>
//               </div>
//             </div>
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <button
//                 style={{ marginTop: "31px" }}
//                 className="btn btn-success"
//                 onClick={handlerowadd}
//               >
//                 Add row
//               </button>
//             </div>
//             <div className="col-lg-3"></div>
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <form className="control">
//                 <label className="form-label">Due Date</label>
//                 <input
//                   className="form-control"
//                   value={getData.dueDate}
//                   type="date"
//                   onChange={(e) => {
//                     setData({ ...getData, dueDate: e.target.value });
//                   }}
//                   required
//                 />
//               </form>
//             </div>
//           </form>
//         </div>
//         <div className="invoicebackground1">
//           <div className="table-responsive">
//             <table className="table table-bordered">
//               <thead className="font-size">
//                 <tr>
//                   <th>S.No</th>
//                   <th style={{ width: "0%" }}>Date</th>
//                   <th style={{ width: "15%" }}>Project Name</th>
//                   <th style={{ width: "10%" }}>Type</th>
//                   {/* <th style={{ width: "6%" }}>Qty</th> */}
//                   <th style={{ width: "4%" }}>Standard</th>
//                   <th style={{ width: "4%" }}>Primier</th>
//                   <th style={{ width: "4%" }}>Twilight</th>
//                   <th style={{ width: "7%" }}>Day to Dust</th>
//                   <th style={{ width: "4%" }}>VRA(5$)</th>
//                   <th style={{ width: "4%" }}>VR(12$)</th>
//                   <th style={{ width: "4%" }}>col-7</th>
//                   <th style={{ width: "4%" }}>col-8</th>
//                   <th style={{ width: "4%" }}>col-9</th>
//                   <th style={{ width: "5%" }}>Price</th>
//                   <th style={{ width: "5%" }}>Tax</th>
//                   {/* <th style={{ width: '10%' }}>₹ Amount</th> */}
//                   {/* {getclientcountry === "91" ? null : ( */}
//                   <th
//                     // className="d-flex border-0 gap-1"
//                     style={{ width: "7%" }}
//                   >
//                     ₹ Amount
//                   </th>
//                   {/* )} */}
//                   <th style={{ width: "7%" }}>$ Rate</th>
//                   <th>Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {tableData.map((item, index) => (
//                   <tr key={item.id}>
//                     <th scope="row">{index + 1}</th>
//                     <td>
//                       <input
//                         style={{ width: "80%" }}
//                         className="form-control pe-0"
//                         type="date"
//                         value={item.date}
//                         onChange={(e) =>
//                           handleUserInputChange(index, "date", e.target.value)
//                         }
//                       />
//                     </td>
//                     <td>
//                       <td>
//                         <input
//                           style={{ width: "100%" }}
//                           className="form-control"
//                           type="text"
//                           value={item.projectName}
//                           onChange={(e) =>
//                             handleUserInputChange(
//                               index,
//                               "projectName",
//                               e.target.value
//                             )
//                           }
//                         />
//                       </td>
//                     </td>
//                     <td>
//                       <div className="position-relative">
//                         {/* <select
//                                                     className='form-control dropdown-toggle custom-select'
//                                                     value={tableData[index].type}
//                                                     onChange={(e) => handleTypeChange(index, e.target.value)}
//                                                 >
//                                                     <option value="">Select a type</option>
//                                                     {getCategoryType.map((item) => (
//                                                         <option key={item.id} value={item.type}>
//                                                             {item.type}
//                                                         </option>
//                                                     ))}
//                                                 </select> */}
//                         <select
//                           className="form-control dropdown-toggle custom-select"
//                           value={tableData[index].type}
//                           onChange={(e) =>
//                             handleTypeChange(index, e.target.value)
//                           }
//                         >
//                           <option value="">Select a type</option>
//                           {getCategoryType.map((item) =>
//                             getclientcountry === "91" &&
//                             item.INRprice !== "" ? (
//                               <option key={item.id} value={item.type}>
//                                 {item.type}
//                               </option>
//                             ) : getclientcountry !== "91" &&
//                               item.price !== "" ? (
//                               <option key={item.id} value={item.type}>
//                                 {item.type}
//                               </option>
//                             ) : null
//                           )}
//                         </select>

//                         <div className="dropdown-arrow"></div>
//                       </div>
//                     </td>
//                     <td>
//                       <input
//                         style={{ width: "100%" }}
//                         className="form-control"
//                         type="text"
//                         value={item.standard}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "standard",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         style={{ width: "100%" }}
//                         className="form-control"
//                         type="text"
//                         value={item.premier}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "premier",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         style={{ width: "100%" }}
//                         className="form-control"
//                         type="text"
//                         value={item.twilight}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "twilight",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         style={{ width: "100%" }}
//                         className="form-control"
//                         type="text"
//                         value={item.day_to_dusk}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "day_to_dusk",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         style={{ width: "100%" }}
//                         className="form-control"
//                         type="text"
//                         value={item.vra}
//                         onChange={(e) =>
//                           handleUserInputChange(index, "vra", e.target.value)
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         style={{ width: "100%" }}
//                         className="form-control"
//                         type="text"
//                         value={item.vr}
//                         onChange={(e) =>
//                           handleUserInputChange(index, "vr", e.target.value)
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         style={{ width: "100%" }}
//                         className="form-control"
//                         type="text"
//                         value={item.col7}
//                         onChange={(e) =>
//                           handleUserInputChange(index, "col7", e.target.value)
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         style={{ width: "100%" }}
//                         className="form-control"
//                         type="text"
//                         value={item.col8}
//                         onChange={(e) =>
//                           handleUserInputChange(index, "col8", e.target.value)
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         style={{ width: "100%" }}
//                         className="form-control"
//                         type="text"
//                         value={item.col9}
//                         onChange={(e) =>
//                           handleUserInputChange(index, "col9", e.target.value)
//                         }
//                       />
//                     </td>
//                     {/* <td>
//                       <input
//                         className="form-control"
//                         type="tel"
//                         value={item.quantity}
//                         onChange={(e) => {
//                           const size = e.target.value
//                             .replace(/\D/g, "")
//                             .slice(0, 30);
//                           handleUserInputChange(index, "quantity", size);
//                         }}
//                       />
//                     </td> */}
//                     <td>
//                       <input
//                         className="form-control"
//                         type="tel"
//                         value={
//                           getclientcountry === "91"
//                             ? `₹${item.price}`
//                             : `$${item.price}`
//                         }
//                         onChange={(e) => {
//                           const size = e.target.value
//                             .replace(/\D/g, "")
//                             .slice(0, 30);
//                           handleUserInputChange(
//                             index,
//                             "price",
//                             size.replace("$", "")
//                           );
//                         }}
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="tel"
//                         value={item.tax}
//                         placeholder="Tax"
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           const onlyNumbers = value.replace(/[^0-9]/g, "");
//                           handleUserInputChange(index, "tax", onlyNumbers);
//                         }}
//                       />
//                     </td>

//                     {/* {getclientcountry === "91" ? null : (
//                     <td>
//                       <p>
//                         ₹{" "}
//                         {(
//                           parseFloat(item.price * exchangeRate) +
//                           parseFloat(
//                             (item.price * exchangeRate * item.tax) / 100
//                           )
//                         ).toFixed(2)}
//                       </p>
//                     </td>
//                     )} */}

//                     {/* {getclientcountry === "91" ? null : ( */}
//                     <td>
//                       <input
//                         style={{ width: "100%" }}
//                         className="form-control ps-2"
//                         type="tel"
//                         value={
//                           item.amount !== undefined && item.amount !== ""
//                             ? item.amount
//                             : (
//                                 parseFloat(item.price * exchangeRate) +
//                                 parseFloat(
//                                   (item.price * exchangeRate * item.tax) / 100
//                                 )
//                               ).toFixed(2)
//                         }
//                         placeholder="Amount"
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           const onlyNumbers = value.replace(/[^0-9]/g, "");
//                           handleUserInputChange(index, "amount", onlyNumbers);
//                         }}
//                       />
//                     </td>
//                     {/* )} */}

//                     {/* <td>
//                       <p>
//                         {getclientcountry === "91"
//                           ? `₹ ${
//                               parseFloat(item.quantity) *
//                                 parseFloat(item.price) +
//                               parseFloat(
//                                 (item.tax * item.quantity * item.price) / 100
//                               )
//                             }`
//                           : `$ ${(
//                               parseFloat(item.quantity) *
//                                 parseFloat(item.price) +
//                               parseFloat(
//                                 (item.tax * item.quantity * item.price) / 100
//                               )
//                             ).toFixed(2)}`}
//                       </p>
//                     </td> */}

//                     <td>
//                       <input
//                         className="form-control ps-2"
//                         type="tel"
//                         value={
//                           item.rate !== undefined && item.rate !== ""
//                             ? item.rate
//                             : (
//                                 parseFloat(item.price * item.tax) / 100 +
//                                 parseFloat(item.price)
//                               ).toFixed(2)
//                         }
//                         placeholder="Rate"
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           const onlyNumbers = value.replace(/[^0-9]/g, "");
//                           handleUserInputChange(index, "rate", onlyNumbers);
//                         }}
//                       />
//                     </td>

//                     <td>
//                       <button
//                         className="btn btn-danger px-1 py-1 d-flex align-items-center"
//                         onClick={() => tablerowdelete(item.id)}
//                       >
//                         <i className="fa-solid fa-trash"></i>
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//           <div className="row mt-4">
//             <div className="col-lg-6 col-md-6 col-sm-12">
//               <label className="form-label">
//                 <b>Notes :</b>
//                 <br />
//                 <textarea
//                   className="form-control notes-textarea"
//                   type="text"
//                   value={getData.notes}
//                   onChange={(e) => {
//                     setData({ ...getData, notes: e.target.value });
//                   }}
//                   required
//                 />
//               </label>
//             </div>
//             <div className="col-lg-6 col-md-6 col-sm-12">
//               <form>
//                 <div className=" row">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Sub Total</b>
//                     </label>
//                   </div>
//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${subtotal.toFixed(2)}`
//                           : `$${subtotal.toFixed(2)}`
//                       }
//                       type="text"
//                       placeholder="Sub Total"
//                     />
//                   </div>
//                 </div>
//                 <div className=" row mt-3">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Paypal Tax</b>
//                     </label>
//                   </div>
//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${tax.toFixed(2)}`
//                           : `$${tax.toFixed(2)}`
//                       }
//                       type="text"
//                       placeholder="Tax"
//                     />
//                   </div>
//                 </div>
//                 <div className=" row mt-3">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Net Total</b>
//                     </label>
//                   </div>
//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${netTotal.toFixed(2)}`
//                           : `$${Math.round(netTotal.toFixed(2))}`
//                       }
//                       type="text"
//                       placeholder="Net Total"
//                     />
//                   </div>
//                 </div>
//               </form>
//             </div>
//           </div>
//           <div className="row">
//             <div className="col-lg-5"></div>
//             <div className="col-lg-7">
//               <div
//                 style={{ marginLeft: "75px" }}
//                 className="d-flex justify-content-evenly mt-3 buttonstyle "
//               >
//                 <button
//                   type="button"
//                   className="btn btn-danger invoice-button"
//                   onClick={handleClearAll}
//                 >
//                   Clear
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-info text-white invoice-button"
//                   style={{ backgroundColor: "#007BFF" }}
//                   onClick={handleback}
//                 >
//                   Back
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-success invoice-button"
//                   onClick={submitdata}
//                 >
//                   Update
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-secondary invoice-button"
//                   onClick={handlenavigate}
//                 >
//                   Print
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }
// export default InvoiceUpdate;

// --------- Second Old code ---------

// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import apiUrl from "../../Environment/Api";
// import { useNavigate, useParams } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const useForceUpdate = () => {
//   const [, forceUpdate] = useState();
//   return useCallback(() => forceUpdate((prev) => !prev), []);
// };

// function InvoiceUpdate() {
//   const forceUpdate = useForceUpdate();
//   const navigate = useNavigate();
//   const [exchangeRate, setExchangeRate] = useState("");

//   const { invoice_id } = useParams();
//   console.log("edit id", invoice_id);

//   const [invoiceData, setInvoiceDetails] = useState({});
//   const [getclientaddress, setclientaddress] = useState("");
//   const [getclientcountry, setclientcountry] = useState("");
//   const [getclientmobile, setclientmobile] = useState("");
//   const [getclientName, setclientName] = useState("");
//   const [selectedClient, setSelectedClient] = useState("");
//   const [invoicedetailsId, setinvoicedetailsId] = useState("");

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const responseDetails = await axios.get(
//           apiUrl + `/invoicedetails/${invoice_id}`
//         );
//         const invoiceDetails = responseDetails.data[0];
//         setInvoiceDetails(invoiceDetails);
//         setSelectedClient(invoiceDetails.clientId);
//         setinvoicedetailsId(invoiceDetails.id);
//         setData({
//           invoiceId: invoiceDetails.invoiceId,
//           date: invoiceDetails.date,
//           dueDate: invoiceDetails.dueDate,
//           notes: invoiceDetails.notes,
//           totalTax: invoiceDetails.totalTax,
//           paymentStatus: invoiceDetails.paymentStatus,
//           totalAmount: invoiceDetails.totalAmount,
//           paymentDate: invoiceDetails.paymentDate,
//         });

//         const responseList = await axios.get(
//           apiUrl + `/invoicelist/${invoice_id}`
//         );
//         // Ensure every row has quantity (default 1)
//         const formattedData = responseList.data.map((item) => ({
//           ...item,
//           quantity: item.quantity || 1,
//         }));
//         setTableData(formattedData);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     };
//     fetchData();
//   }, [invoice_id]);

//   const [ClientDetails, setClientDetails] = useState([]);
//   const clientdetails = async () => {
//     try {
//       const response = await axios.get(apiUrl + "/clientdetails");
//       if (response) setClientDetails(response.data);
//     } catch (error) {
//       console.error("Error fetching client details:", error);
//     }
//   };

//   useEffect(() => {
//     clientdetails();
//     categorytype();

//     const fetchExchangeRate = async () => {
//       try {
//         const response = await fetch(
//           "https://api.frankfurter.app/latest?from=USD&to=INR"
//         );
//         const data = await response.json();
//         setExchangeRate(data.rates.INR || 83);
//       } catch (error) {
//         setExchangeRate(83);
//       }
//     };
//     fetchExchangeRate();
//   }, []);

//   const [currentDate] = useState(getFormattedDate());
//   const [tableData, setTableData] = useState([]);
//   const [subtotal, setSubtotal] = useState(0);
//   const [tax, setTax] = useState(0);
//   const [netTotal, setNetTotal] = useState(0);
//   const [clientRowCreated, setClientRowCreated] = useState(false);

//   function filter() {
//     const client = ClientDetails.find((data) => data.id === selectedClient);
//     if (client) {
//       setclientName(client.clientName);
//       setclientaddress(client.address);
//       setclientcountry(client.countrycode);
//       setclientmobile(client.mobile);
//     }
//   }

//   useEffect(() => {
//     if (ClientDetails.length > 0 && selectedClient) filter();
//   }, [ClientDetails, selectedClient]);

//   const handlerowadd = (e) => {
//     e.preventDefault();
//     const newId = Date.now();
//     const newRow = {
//       id: newId,
//       date: getFormattedDate(),
//       projectName: "",
//       type: "",
//       quantity: 1,
//       price: 0,
//       tax: "",
//       standard: "",
//       premier: "",
//       twilight: "",
//       day_to_dusk: "",
//       vra: "",
//       vr: "",
//       col7: "",
//       col8: "",
//       col9: "",
//       amount: "",
//       rate: "",
//     };
//     setTableData((prev) => [...prev, newRow]);
//     setClientRowCreated(true);
//   };

//   const handleTypeChange = (index, value) => {
//     if (!value) return;
//     setTableData((prev) => {
//       const updated = [...prev];
//       updated[index].type = value;

//       const cat = getCategoryType.find((item) => item.type === value);
//       if (cat) {
//         updated[index].price =
//           getclientcountry === "91" ? cat.INRprice : cat.price;
//       }

//       if (index === updated.length - 1) {
//         const newId = Date.now();
//         updated.push({
//           id: newId,
//           date: getFormattedDate(),
//           projectName: "",
//           type: "",
//           quantity: 1,
//           price: 0,
//           tax: "",
//           standard: "",
//           premier: "",
//           twilight: "",
//           day_to_dusk: "",
//           vra: "",
//           vr: "",
//           col7: "",
//           col8: "",
//           col9: "",
//           amount: "",
//           rate: "",
//         });
//         setClientRowCreated(true);
//       }
//       return updated;
//     });
//   };

//   const handleUserInputChange = (index, property, value) => {
//     setTableData((prev) => {
//       const updated = [...prev];
//       updated[index][property] = value;
//       return updated;
//     });
//   };

//   useEffect(() => {
//     let sub = 0,
//       tx = 0;
//     tableData.forEach((item) => {
//       const qty = parseFloat(item.quantity) || 1;
//       const price = parseFloat(item.price) || 0;
//       const taxRate = parseFloat(item.tax) || 0;
//       const lineTotal = qty * price;
//       sub += lineTotal;
//       tx += (lineTotal * taxRate) / 100;
//     });
//     setSubtotal(sub);
//     setTax(tx);
//     setNetTotal(sub + tx);
//   }, [tableData]);

//   const [deleteids, setDeleteIds] = useState([]);
//   const tablerowdelete = (id) => {
//     setTableData((prev) => prev.filter((item) => item.id !== id));
//     if (typeof id === "number" && id < 1000000) {
//       setDeleteIds((prev) => [...prev, id]);
//     }
//   };

//   const handleClearAll = () => {
//     setTableData([]);
//     setClientRowCreated(false);
//   };

//   const handleback = () => navigate("/invoice");

//   const [getCategoryType, setCategoryType] = useState([]);
//   const categorytype = async () => {
//     try {
//       const response = await axios.get(apiUrl + "/category");
//       setCategoryType(response.data || []);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   function getFormattedDate() {
//     const today = new Date();
//     const year = today.getFullYear();
//     let month = today.getMonth() + 1;
//     let day = today.getDate();
//     month = month < 10 ? `0${month}` : month;
//     day = day < 10 ? `0${day}` : day;
//     return `${year}-${month}-${day}`;
//   }

//   const validateForm = () => {
//     const empty = [];
//     if (!selectedClient) empty.push("Client Name");
//     if (!getData.date) empty.push("Date");
//     if (!getData.dueDate) empty.push("Due Date");

//     tableData.forEach((item, i) => {
//       if (item.type) {
//         if (!item.projectName) empty.push(`Project Name at row ${i + 1}`);
//         if (!item.tax) empty.push(`Tax at row ${i + 1}`);
//       }
//     });

//     if (empty.length > 0) {
//       alert(`Please fill: ${empty.join(", ")}`);
//       return false;
//     }
//     return true;
//   };

//   const [isDataSubmitted, setIsDataSubmitted] = useState(false);
//   const [getData, setData] = useState({
//     invoiceId: "",
//     clientName: "",
//     date: "",
//     dueDate: "",
//     notes: "",
//     totalTax: "",
//     paymentStatus: "Unpaid",
//     totalAmount: "",
//     paymentDate: "",
//   });

//   const toaster = (cb) =>
//     toast.success("Updated successfully!", { autoClose: 1000, onClose: cb });

//   const submitdata = async () => {
//     if (isDataSubmitted || !validateForm()) return;
//     setIsDataSubmitted(true);

//     try {
//       const filtered = tableData.filter((item) => item.type?.trim());

//       const mainUpdate = {
//         invoiceId: invoice_id,
//         clientName: selectedClient,
//         date: getData.date,
//         dueDate: getData.dueDate,
//         totalAmount: netTotal.toFixed(2),
//         notes: getData.notes,
//         totalTax: tax.toFixed(2),
//         paymentStatus: "Unpaid",
//         paymentDate: "",
//       };

//       await axios.put(`${apiUrl}/invoicedetailsupdate/${invoicedetailsId}`, {
//         ...getData,
//         ...mainUpdate,
//       });

//       // Delete removed rows
//       for (const id of deleteids) {
//         await axios.delete(`${apiUrl}/invoicelist/${id}`);
//       }
//       setDeleteIds([]);

//       // Prepare list data
//       const listData = filtered.map((data) => {
//         const qty = parseFloat(data.quantity) || 1;
//         const price = parseFloat(data.price) || 0;
//         const taxRate = parseFloat(data.tax) || 0;

//         const rateUSD = (price * (1 + taxRate / 100)).toFixed(2);
//         const amountINR = (price * exchangeRate * (1 + taxRate / 100)).toFixed(
//           2
//         );
//         const totalAmt = (qty * price * (1 + taxRate / 100)).toFixed(2);

//         return {
//           id: data.id,
//           invoiceId: invoice_id,
//           date: data.date || getFormattedDate(),
//           clientName: selectedClient,
//           projectName: data.projectName || "",
//           type: data.type || "",
//           quantity: qty,
//           standard: data.standard || "",
//           premier: data.premier || "",
//           twilight: data.twilight || "",
//           day_to_dusk: data.day_to_dusk || "",
//           vra: data.vra || "",
//           vr: data.vr || "",
//           col7: data.col7 || "",
//           col8: data.col8 || "",
//           col9: data.col9 || "",
//           price: price.toString(),
//           tax: taxRate.toString(),
//           amount: data.amount || amountINR,
//           rate: data.rate || rateUSD,
//           totalAmount: totalAmt,
//         };
//       });

//       console.log("Sending invoicelistupdate →", listData);
//       await axios.post(apiUrl + "/invoicelistupdate", listData);

//       toaster(() => navigate("/invoice"));
//     } catch (err) {
//       console.error(err);
//       toast.error("Update failed");
//       setIsDataSubmitted(false);
//     }
//   };

//   const handlenavigate = async () => {
//     await submitdata();
//     if (isDataSubmitted) {
//       navigate(`/invoice/invoiceprint/${invoice_id}`);
//     }
//   };

//   return (
//     <>
//       <ToastContainer />
//       <h3 className="text-center">Edit Invoice</h3>
//       <hr />
//       <div className="mx-1">
//         <div className="invoicebackground1">
//           <form className="row">
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <label className="form-label">Invoice No.</label>
//               <input
//                 className="form-control"
//                 value={invoice_id}
//                 type="text"
//                 readOnly
//               ></input>
//             </div>
//             <div className="col-lg-6 col-md-4"></div>
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <label className="form-label">Date :</label>
//               <input
//                 className="form-control"
//                 type="date"
//                 value={getData.date || ""}
//                 onChange={(e) => setData({ ...getData, date: e.target.value })}
//                 required
//               />
//             </div>
//           </form>
//         </div>

//         <div className="invoicebackground1">
//           <form className="row">
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <div className="mx-3 dropdown">
//                 <label className="form-label">Client Name :</label>
//                 <div className="position-relative">
//                   <select
//                     className="form-control dropdown-toggle custom-select"
//                     value={selectedClient}
//                     disabled
//                   >
//                     <option value="">{getclientName}</option>
//                   </select>
//                   <div className="dropdown-arrow"></div>
//                 </div>
//               </div>
//             </div>
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <button
//                 style={{ marginTop: "31px" }}
//                 className="btn btn-success"
//                 onClick={handlerowadd}
//               >
//                 Add row
//               </button>
//             </div>
//             <div className="col-lg-3"></div>
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <form className="control">
//                 <label className="form-label">Due Date</label>
//                 <input
//                   className="form-control"
//                   value={getData.dueDate || ""}
//                   type="date"
//                   onChange={(e) =>
//                     setData({ ...getData, dueDate: e.target.value })
//                   }
//                   required
//                 />
//               </form>
//             </div>
//           </form>
//         </div>

//         <div className="invoicebackground1">
//           <div className="table-responsive">
//             <table className="table table-bordered">
//               <thead className="font-size">
//                 <tr>
//                   <th>S.No</th>
//                   <th style={{ width: "0%" }}>Date</th>
//                   <th style={{ width: "15%" }}>Address</th>
//                   <th style={{ width: "10%" }}>Type</th>
//                   <th style={{ width: "4%" }}>Standard</th>
//                   <th style={{ width: "4%" }}>Primier</th>
//                   <th style={{ width: "4%" }}>Twilight</th>
//                   <th style={{ width: "7%" }}>Day to Dust</th>
//                   <th style={{ width: "4%" }}>VRA(5$)</th>
//                   <th style={{ width: "4%" }}>VR(12$)</th>
//                   <th style={{ width: "4%" }}>col-7</th>
//                   <th style={{ width: "4%" }}>col-8</th>
//                   <th style={{ width: "4%" }}>col-9</th>
//                   <th style={{ width: "5%" }}>$ Price</th>
//                   <th style={{ width: "5%" }}>Tax (%)</th>
//                   <th style={{ width: "7%" }}>₹ Amount</th>
//                   <th style={{ width: "7%" }}>$ Rate</th>
//                   <th>Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {tableData.map((item, index) => (
//                   <tr key={item.id}>
//                     <th scope="row">{index + 1}</th>
//                     <td>
//                       <input
//                         style={{ width: "80%" }}
//                         className="form-control pe-0"
//                         type="date"
//                         value={item.date || ""}
//                         onChange
//                         change={(e) =>
//                           handleUserInputChange(index, "date", e.target.value)
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         style={{ width: "100%" }}
//                         className="form-control"
//                         type="text"
//                         value={item.projectName || ""}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "projectName",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <div className="position-relative">
//                         <select
//                           className="form-control dropdown-toggle custom-select"
//                           value={item.type || ""}
//                           onChange={(e) =>
//                             handleTypeChange(index, e.target.value)
//                           }
//                         >
//                           <option value="">Select a type</option>
//                           {getCategoryType.map((cat) =>
//                             getclientcountry === "91" && cat.INRprice ? (
//                               <option key={cat.id} value={cat.type}>
//                                 {cat.type}
//                               </option>
//                             ) : getclientcountry !== "91" && cat.price ? (
//                               <option key={cat.id} value={cat.type}>
//                                 {cat.type}
//                               </option>
//                             ) : null
//                           )}
//                         </select>
//                         <div className="dropdown-arrow"></div>
//                       </div>
//                     </td>
//                     {[
//                       "standard",
//                       "premier",
//                       "twilight",
//                       "day_to_dusk",
//                       "vra",
//                       "vr",
//                       "col7",
//                       "col8",
//                       "col9",
//                     ].map((f) => (
//                       <td key={f}>
//                         <input
//                           style={{ width: "100%" }}
//                           className="form-control"
//                           type="text"
//                           value={item[f] || ""}
//                           onChange={(e) =>
//                             handleUserInputChange(index, f, e.target.value)
//                           }
//                         />
//                       </td>
//                     ))}
//                     <td>
//                       <input
//                         className="form-control"
//                         type="tel"
//                         value={
//                           getclientcountry === "91"
//                             ? `${item.price || 0}`
//                             : `${item.price || 0}`
//                         }
//                         onChange={(e) => {
//                           const val = e.target.value.replace(/[^\d.]/g, "");
//                           handleUserInputChange(index, "price", val);
//                         }}
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="tel"
//                         value={item.tax || ""}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "tax",
//                             e.target.value.replace(/\D/g, "")
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         style={{ width: "100%" }}
//                         className="form-control ps-2"
//                         type="tel"
//                         value={
//                           item.amount ||
//                           (
//                             (parseFloat(item.price) || 0) *
//                             exchangeRate *
//                             (1 + (parseFloat(item.tax) || 0) / 100)
//                           ).toFixed(2)
//                         }
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "amount",
//                             e.target.value.replace(/[^0-9.]/g, "")
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control ps-2"
//                         type="tel"
//                         value={
//                           item.rate ||
//                           (
//                             (parseFloat(item.price) || 0) *
//                             (1 + (parseFloat(item.tax) || 0) / 100)
//                           ).toFixed(2)
//                         }
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "rate",
//                             e.target.value.replace(/[^0-9.]/g, "")
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <button
//                         className="btn btn-danger px-1 py-1 d-flex align-items-center"
//                         onClick={() => tablerowdelete(item.id)}
//                       >
//                         <i className="fa-solid fa-trash"></i>
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           <div className="row mt-4">
//             <div className="col-lg-6 col-md-6 col-sm-12">
//               <label className="form-label">
//                 <b>Notes :</b>
//                 <br />
//                 <textarea
//                   className="form-control notes-textarea"
//                   type="text"
//                   value={getData.notes || ""}
//                   onChange={(e) => {
//                     setData({ ...getData, notes: e.target.value });
//                   }}
//                   required
//                 />
//               </label>
//             </div>
//             <div className="col-lg-6 col-md-6 col-sm-12">
//               <form>
//                 <div className="row">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Sub Total</b>
//                     </label>
//                   </div>
//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${subtotal.toFixed(2)}`
//                           : `$${subtotal.toFixed(2)}`
//                       }
//                       type="text"
//                       placeholder="Sub Total"
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="row mt-3">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Paypal Tax</b>
//                     </label>
//                   </div>
//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${tax.toFixed(2)}`
//                           : `$${tax.toFixed(2)}`
//                       }
//                       type="text"
//                       placeholder="Tax"
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="row mt-3">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Net Total</b>
//                     </label>
//                   </div>
//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${netTotal.toFixed(2)}`
//                           : `$${netTotal.toFixed(2)}`
//                       }
//                       type="text"
//                       placeholder="Net Total"
//                       readOnly
//                     />
//                   </div>
//                 </div>
//               </form>
//             </div>
//           </div>

//           <div className="row">
//             <div className="col-lg-5"></div>
//             <div className="col-lg-7">
//               <div
//                 style={{ marginLeft: "75px" }}
//                 className="d-flex justify-content-evenly mt-3 buttonstyle"
//               >
//                 <button
//                   type="button"
//                   className="btn btn-danger invoice-button"
//                   onClick={handleClearAll}
//                 >
//                   Clear
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-info text-white invoice-button"
//                   style={{ backgroundColor: "#007BFF" }}
//                   onClick={handleback}
//                 >
//                   Back
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-success invoice-button"
//                   onClick={submitdata}
//                 >
//                   Update
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-secondary invoice-button"
//                   onClick={handlenavigate}
//                 >
//                   Print
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default InvoiceUpdate;

// ----------- update code - 12-12-2025 ----------

// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import apiUrl from "../../Environment/Api";
// import { useNavigate, useParams } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const useForceUpdate = () => {
//   const [, forceUpdate] = useState();
//   return useCallback(() => forceUpdate((prev) => !prev), []);
// };

// function InvoiceUpdate() {
//   const forceUpdate = useForceUpdate();
//   const navigate = useNavigate();
//   const [exchangeRate, setExchangeRate] = useState("");

//   const { invoice_id } = useParams();
//   console.log("edit id", invoice_id);

//   const [invoiceData, setInvoiceDetails] = useState({});
//   const [getclientaddress, setclientaddress] = useState("");
//   const [getclientcountry, setclientcountry] = useState("");
//   const [getclientmobile, setclientmobile] = useState("");
//   const [getclientName, setclientName] = useState("");
//   const [selectedClient, setSelectedClient] = useState("");
//   const [invoicedetailsId, setinvoicedetailsId] = useState("");

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const responseDetails = await axios.get(
//           apiUrl + `/invoicedetails/${invoice_id}`
//         );
//         const invoiceDetails = responseDetails.data[0];
//         setInvoiceDetails(invoiceDetails);
//         setSelectedClient(invoiceDetails.clientId);
//         setinvoicedetailsId(invoiceDetails.id);
//         setData({
//           invoiceId: invoiceDetails.invoiceId,
//           date: invoiceDetails.date,
//           dueDate: invoiceDetails.dueDate,
//           notes: invoiceDetails.notes,
//           totalTax: invoiceDetails.totalTax,
//           paymentStatus: invoiceDetails.paymentStatus,
//           totalAmount: invoiceDetails.totalAmount,
//           paymentDate: invoiceDetails.paymentDate,
//         });

//         const responseList = await axios.get(
//           apiUrl + `/invoicelist/${invoice_id}`
//         );
//         // Ensure every row has quantity (default 1)
//         const formattedData = responseList.data.map((item) => ({
//           ...item,
//           quantity: item.quantity || 1,
//         }));
//         setTableData(formattedData);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     };
//     fetchData();
//   }, [invoice_id]);

//   const [ClientDetails, setClientDetails] = useState([]);
//   const clientdetails = async () => {
//     try {
//       const response = await axios.get(apiUrl + "/clientdetails");
//       if (response) setClientDetails(response.data);
//     } catch (error) {
//       console.error("Error fetching client details:", error);
//     }
//   };

//   useEffect(() => {
//     clientdetails();
//     categorytype();

//     const fetchExchangeRate = async () => {
//       try {
//         const response = await fetch(
//           "https://api.frankfurter.app/latest?from=USD&to=INR"
//         );
//         const data = await response.json();
//         setExchangeRate(data.rates.INR || 83);
//       } catch (error) {
//         setExchangeRate(83);
//       }
//     };
//     fetchExchangeRate();
//   }, []);

//   const [currentDate] = useState(getFormattedDate());
//   const [tableData, setTableData] = useState([]);
//   const [subtotal, setSubtotal] = useState(0);
//   const [tax, setTax] = useState(0);
//   const [netTotal, setNetTotal] = useState(0);
//   const [clientRowCreated, setClientRowCreated] = useState(false);
//   const [storedNetTotal, setStoredNetTotal] = useState(0);

//   function filter() {
//     const client = ClientDetails.find((data) => data.id === selectedClient);
//     if (client) {
//       setclientName(client.clientName);
//       setclientaddress(client.address);
//       setclientcountry(client.countrycode);
//       setclientmobile(client.mobile);
//     }
//   }

//   useEffect(() => {
//     if (ClientDetails.length > 0 && selectedClient) filter();
//   }, [ClientDetails, selectedClient]);

//   const handlerowadd = (e) => {
//     e.preventDefault();
//     const newId = Date.now();
//     const newRow = {
//       id: newId,
//       date: getFormattedDate(),
//       projectName: "",
//       type: "",
//       quantity: 1,
//       price: 0,
//       tax: "",
//       standard: "",
//       premier: "",
//       twilight: "",
//       day_to_dusk: "",
//       vra: "",
//       vr: "",
//       col7: "",
//       col8: "",
//       col9: "",
//       amount: "",
//       rate: "",
//     };
//     setTableData((prev) => [...prev, newRow]);
//     setClientRowCreated(true);
//   };

//   const handleTypeChange = (index, value) => {
//     if (!value) return;
//     setTableData((prev) => {
//       const updated = [...prev];
//       updated[index].type = value;

//       const cat = getCategoryType.find((item) => item.type === value);
//       if (cat) {
//         updated[index].price =
//           getclientcountry === "91" ? cat.INRprice : cat.price;
//       }

//       if (index === updated.length - 1) {
//         const newId = Date.now();
//         updated.push({
//           id: newId,
//           date: getFormattedDate(),
//           projectName: "",
//           type: "",
//           quantity: 1,
//           price: 0,
//           tax: "",
//           standard: "",
//           premier: "",
//           twilight: "",
//           day_to_dusk: "",
//           vra: "",
//           vr: "",
//           col7: "",
//           col8: "",
//           col9: "",
//           amount: "",
//           rate: "",
//         });
//         setClientRowCreated(true);
//       }
//       return updated;
//     });
//   };

//   const handleUserInputChange = (index, property, value) => {
//     setTableData((prev) => {
//       const updated = [...prev];
//       updated[index][property] = value;
//       return updated;
//     });
//   };

//   useEffect(() => {
//     let sub = 0,
//       tx = 0;
//     tableData.forEach((item) => {
//       const qty = parseFloat(item.quantity) || 1;
//       const price = parseFloat(item.price) || 0;
//       const taxRate = parseFloat(item.tax) || 0;
//       const lineTotal = qty * price;
//       sub += lineTotal;
//       tx += (lineTotal * taxRate) / 100;
//     });
//     setSubtotal(sub);
//     setTax(tx);
//     setNetTotal(sub + tx);
//   }, [tableData]);

//   useEffect(() => {
//     let finalAmount = 0;

//     if (getclientcountry === "91") {
//       // FOREIGN → USD converted amount
//       finalAmount = netTotal * exchangeRate;
//     } else {
//       // INDIA → INR direct amount
//       finalAmount = netTotal;
//     }

//     setStoredNetTotal(finalAmount);
//   }, [netTotal, getclientcountry, exchangeRate]);

//   const [deleteids, setDeleteIds] = useState([]);
//   const tablerowdelete = (id) => {
//     setTableData((prev) => prev.filter((item) => item.id !== id));
//     if (typeof id === "number" && id < 1000000) {
//       setDeleteIds((prev) => [...prev, id]);
//     }
//   };

//   const handleClearAll = () => {
//     setTableData([]);
//     setClientRowCreated(false);
//   };

//   const handleback = () => navigate("/invoice");

//   const [getCategoryType, setCategoryType] = useState([]);
//   const categorytype = async () => {
//     try {
//       const response = await axios.get(apiUrl + "/category");
//       setCategoryType(response.data || []);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   function getFormattedDate() {
//     const today = new Date();
//     const year = today.getFullYear();
//     let month = today.getMonth() + 1;
//     let day = today.getDate();
//     month = month < 10 ? `0${month}` : month;
//     day = day < 10 ? `0${day}` : day;
//     return `${year}-${month}-${day}`;
//   }

//   const validateForm = () => {
//     const empty = [];
//     if (!selectedClient) empty.push("Client Name");
//     if (!getData.date) empty.push("Date");
//     if (!getData.dueDate) empty.push("Due Date");

//     tableData.forEach((item, i) => {
//       if (item.type) {
//         if (!item.projectName) empty.push(`Project Name at row ${i + 1}`);
//         if (!item.tax) empty.push(`Tax at row ${i + 1}`);
//       }
//     });

//     if (empty.length > 0) {
//       alert(`Please fill: ${empty.join(", ")}`);
//       return false;
//     }
//     return true;
//   };

//   const [isDataSubmitted, setIsDataSubmitted] = useState(false);
//   const [getData, setData] = useState({
//     invoiceId: "",
//     clientName: "",
//     date: "",
//     dueDate: "",
//     notes: "",
//     totalTax: "",
//     paymentStatus: "Unpaid",
//     totalAmount: "",
//     paymentDate: "",
//   });

//   const toaster = (cb) =>
//     toast.success("Updated successfully!", { autoClose: 1000, onClose: cb });

//   const submitdata = async () => {
//     if (isDataSubmitted || !validateForm()) return;
//     setIsDataSubmitted(true);

//     try {
//       const filtered = tableData.filter((item) => item.type?.trim());

//       const mainUpdate = {
//         invoiceId: invoice_id,
//         clientName: selectedClient,
//         date: getData.date,
//         dueDate: getData.dueDate,
//         totalAmount: netTotal.toFixed(2),
//         notes: getData.notes,
//         totalTax: tax.toFixed(2),
//         paymentStatus: "Unpaid",
//         paymentDate: "",
//       };

//       await axios.put(`${apiUrl}/invoicedetailsupdate/${invoicedetailsId}`, {
//         ...getData,
//         ...mainUpdate,
//       });

//       // Delete removed rows
//       for (const id of deleteids) {
//         await axios.delete(`${apiUrl}/invoicelist/${id}`);
//       }
//       setDeleteIds([]);

//       // Prepare list data
//       const listData = filtered.map((data) => {
//         const qty = parseFloat(data.quantity) || 1;
//         const price = parseFloat(data.price) || 0;
//         const taxRate = parseFloat(data.tax) || 0;

//         const rateUSD = (price * (1 + taxRate / 100)).toFixed(2);
//         const amountINR = (price * exchangeRate * (1 + taxRate / 100)).toFixed(
//           2
//         );
//         const totalAmt = (qty * price * (1 + taxRate / 100)).toFixed(2);

//         return {
//           id: data.id,
//           invoiceId: invoice_id,
//           date: data.date || getFormattedDate(),
//           clientName: selectedClient,
//           projectName: data.projectName || "",
//           type: data.type || "",
//           quantity: qty,
//           standard: data.standard || "",
//           premier: data.premier || "",
//           twilight: data.twilight || "",
//           day_to_dusk: data.day_to_dusk || "",
//           vra: data.vra || "",
//           vr: data.vr || "",
//           col7: data.col7 || "",
//           col8: data.col8 || "",
//           col9: data.col9 || "",
//           price: price.toString(),
//           tax: taxRate.toString(),
//           amount: data.amount || amountINR,
//           rate: data.rate || rateUSD,
//           totalAmount: totalAmt,
//         };
//       });

//       console.log("Sending invoicelistupdate →", listData);
//       await axios.post(apiUrl + "/invoicelistupdate", listData);

//       toaster(() => navigate("/invoice"));
//     } catch (err) {
//       console.error(err);
//       toast.error("Update failed");
//       setIsDataSubmitted(false);
//     }
//   };

//   const handlenavigate = async () => {
//     await submitdata();
//     if (isDataSubmitted) {
//       navigate(`/invoice/invoiceprint/${invoice_id}`);
//     }
//   };

//   return (
//     <>
//       <ToastContainer />
//       <h3 className="text-center">Edit Invoice</h3>
//       <hr />
//       <div className="mx-1">
//         <div className="invoicebackground1">
//           <form className="row">
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <label className="form-label">Invoice No.</label>
//               <input
//                 className="form-control"
//                 value={invoice_id}
//                 type="text"
//                 readOnly
//               ></input>
//             </div>
//             <div className="col-lg-6 col-md-4"></div>
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <label className="form-label">Date :</label>
//               <input
//                 className="form-control"
//                 type="date"
//                 value={getData.date || ""}
//                 onChange={(e) => setData({ ...getData, date: e.target.value })}
//                 required
//               />
//             </div>
//           </form>
//         </div>

//         <div className="invoicebackground1">
//           <form className="row">
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <div className="mx-3 dropdown">
//                 <label className="form-label">Client Name :</label>
//                 <div className="position-relative">
//                   <select
//                     className="form-control dropdown-toggle custom-select"
//                     value={selectedClient}
//                     disabled
//                   >
//                     <option value="">{getclientName}</option>
//                   </select>
//                   <div className="dropdown-arrow"></div>
//                 </div>
//               </div>
//             </div>
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <button
//                 style={{ marginTop: "31px" }}
//                 className="btn btn-success"
//                 onClick={handlerowadd}
//               >
//                 Add row
//               </button>
//             </div>
//             <div className="col-lg-3"></div>
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <form className="control">
//                 <label className="form-label">Due Date</label>
//                 <input
//                   className="form-control"
//                   value={getData.dueDate || ""}
//                   type="date"
//                   onChange={(e) =>
//                     setData({ ...getData, dueDate: e.target.value })
//                   }
//                   required
//                 />
//               </form>
//             </div>
//           </form>
//         </div>

//         <div className="invoicebackground1">
//           <div className="table-responsive">
//             <table className="table table-bordered">
//               <thead className="font-size">
//                 <tr>
//                   <th>S.No</th>
//                   <th style={{ width: "0%" }}>Date</th>
//                   <th style={{ width: "15%" }}>Address</th>
//                   <th style={{ width: "10%" }}>Type</th>
//                   <th style={{ width: "4%" }}>Standard</th>
//                   <th style={{ width: "4%" }}>Primier</th>
//                   <th style={{ width: "4%" }}>Twilight</th>
//                   <th style={{ width: "7%" }}>Day to Dust</th>
//                   <th style={{ width: "4%" }}>VRA(5$)</th>
//                   <th style={{ width: "4%" }}>VR(12$)</th>
//                   <th style={{ width: "4%" }}>col-7</th>
//                   <th style={{ width: "4%" }}>col-8</th>
//                   <th style={{ width: "4%" }}>col-9</th>
//                   <th style={{ width: "5%" }}>$ Price</th>
//                   <th style={{ width: "5%" }}>Tax (%)</th>
//                   <th style={{ width: "7%" }}>₹ Amount</th>
//                   <th style={{ width: "7%" }}>$ Rate</th>
//                   <th>Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {tableData.map((item, index) => (
//                   <tr key={item.id}>
//                     <th scope="row">{index + 1}</th>
//                     <td>
//                       <input
//                         style={{ width: "80%" }}
//                         className="form-control pe-0"
//                         type="date"
//                         value={item.date || ""}
//                         onChange={(e) =>
//                           handleUserInputChange(index, "date", e.target.value)
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         style={{ width: "100%" }}
//                         className="form-control"
//                         type="text"
//                         value={item.projectName || ""}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "projectName",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <div className="position-relative">
//                         <select
//                           className="form-control dropdown-toggle custom-select"
//                           value={item.type || ""}
//                           onChange={(e) =>
//                             handleTypeChange(index, e.target.value)
//                           }
//                         >
//                           <option value="">Select a type</option>
//                           {getCategoryType.map((cat) =>
//                             getclientcountry === "91" && cat.INRprice ? (
//                               <option key={cat.id} value={cat.type}>
//                                 {cat.type}
//                               </option>
//                             ) : getclientcountry !== "91" && cat.price ? (
//                               <option key={cat.id} value={cat.type}>
//                                 {cat.type}
//                               </option>
//                             ) : null
//                           )}
//                         </select>
//                         <div className="dropdown-arrow"></div>
//                       </div>
//                     </td>
//                     {[
//                       "standard",
//                       "premier",
//                       "twilight",
//                       "day_to_dusk",
//                       "vra",
//                       "vr",
//                       "col7",
//                       "col8",
//                       "col9",
//                     ].map((f) => (
//                       <td key={f}>
//                         <input
//                           style={{ width: "100%" }}
//                           className="form-control"
//                           type="text"
//                           value={item[f] || ""}
//                           onChange={(e) =>
//                             handleUserInputChange(index, f, e.target.value)
//                           }
//                         />
//                       </td>
//                     ))}
//                     <td>
//                       <input
//                         className="form-control"
//                         type="tel"
//                         value={
//                           getclientcountry === "91"
//                             ? `${item.price || 0}`
//                             : `${item.price || 0}`
//                         }
//                         onChange={(e) => {
//                           const val = e.target.value.replace(/[^\d.]/g, "");
//                           handleUserInputChange(index, "price", val);
//                         }}
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="tel"
//                         value={item.tax || ""}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "tax",
//                             e.target.value.replace(/\D/g, "")
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         style={{ width: "100%" }}
//                         className="form-control ps-2"
//                         type="tel"
//                         value={
//                           item.amount ||
//                           (
//                             (parseFloat(item.price) || 0) *
//                             exchangeRate *
//                             (1 + (parseFloat(item.tax) || 0) / 100)
//                           ).toFixed(2)
//                         }
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "amount",
//                             e.target.value.replace(/[^0-9.]/g, "")
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control ps-2"
//                         type="tel"
//                         value={
//                           item.rate ||
//                           (
//                             (parseFloat(item.price) || 0) *
//                             (1 + (parseFloat(item.tax) || 0) / 100)
//                           ).toFixed(2)
//                         }
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "rate",
//                             e.target.value.replace(/[^0-9.]/g, "")
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <button
//                         className="btn btn-danger px-1 py-1 d-flex align-items-center"
//                         onClick={() => tablerowdelete(item.id)}
//                       >
//                         <i className="fa-solid fa-trash"></i>
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           <div className="row mt-4">
//             <div className="col-lg-6 col-md-6 col-sm-12">
//               <label className="form-label">
//                 <b>Notes :</b>
//                 <br />
//                 <textarea
//                   className="form-control notes-textarea"
//                   type="text"
//                   value={getData.notes || ""}
//                   onChange={(e) => {
//                     setData({ ...getData, notes: e.target.value });
//                   }}
//                   required
//                 />
//               </label>
//             </div>
//             <div className="col-lg-6 col-md-6 col-sm-12">
//               <form>
//                 <div className="row">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Sub Total</b>
//                     </label>
//                   </div>
//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${subtotal.toFixed(2)}`
//                           : `$${subtotal.toFixed(2)}`
//                       }
//                       type="text"
//                       placeholder="Sub Total"
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="row mt-3">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Paypal Tax</b>
//                     </label>
//                   </div>
//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${tax.toFixed(2)}`
//                           : `$${tax.toFixed(2)}`
//                       }
//                       type="text"
//                       placeholder="Tax"
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="row mt-3">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Net Total</b>
//                     </label>
//                   </div>
//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${Math.round(storedNetTotal).toFixed(2)}`
//                           : `$${Math.round(storedNetTotal).toFixed(2)}`
//                       }
//                       type="text"
//                       placeholder="Net Total"
//                       readOnly
//                     />
//                   </div>
//                 </div>
//               </form>
//             </div>
//           </div>

//           <div className="row">
//             <div className="col-lg-5"></div>
//             <div className="col-lg-7">
//               <div
//                 style={{ marginLeft: "75px" }}
//                 className="d-flex justify-content-evenly mt-3 buttonstyle"
//               >
//                 <button
//                   type="button"
//                   className="btn btn-danger invoice-button"
//                   onClick={handleClearAll}
//                 >
//                   Clear
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-info text-white invoice-button"
//                   style={{ backgroundColor: "#007BFF" }}
//                   onClick={handleback}
//                 >
//                   Back
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-success invoice-button"
//                   onClick={submitdata}
//                 >
//                   Update
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-secondary invoice-button"
//                   onClick={handlenavigate}
//                 >
//                   Print
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default InvoiceUpdate;


// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import apiUrl from "../../Environment/Api";
// import { useNavigate, useParams } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const useForceUpdate = () => {
//   const [, forceUpdate] = useState();
//   return useCallback(() => forceUpdate((prev) => !prev), []);
// };

// function InvoiceUpdate() {
//   const forceUpdate = useForceUpdate();
//   const navigate = useNavigate();
//   const [exchangeRate, setExchangeRate] = useState("");

//   const { invoice_id } = useParams();
//   console.log("edit id", invoice_id);

//   const [invoiceData, setInvoiceDetails] = useState({});
//   const [getclientaddress, setclientaddress] = useState("");
//   const [getclientcountry, setclientcountry] = useState("");
//   const [getclientmobile, setclientmobile] = useState("");
//   const [getclientName, setclientName] = useState("");
//   const [selectedClient, setSelectedClient] = useState("");
//   const [invoicedetailsId, setinvoicedetailsId] = useState("");

//   // State for dynamic columns
//   const [visibleColumns, setVisibleColumns] = useState(0);
//   const [columnNames, setColumnNames] = useState({
//     col7: "Column 7",
//     col8: "Column 8",
//     col9: "Column 9",
//     col10: "Column 10",
//     col11: "Column 11",
//     col12: "Column 12"
//   });
//   const [isEditingColumnName, setIsEditingColumnName] = useState(null);
//   const [tempColumnName, setTempColumnName] = useState("");

//   // Function to add a new column
//   const handleAddColumn = () => {
//     if (visibleColumns < 6) {
//       setVisibleColumns(visibleColumns + 1);
//     }
//   };

//   // Function to start editing column name
//   const handleEditColumnName = (columnKey) => {
//     setIsEditingColumnName(columnKey);
//     setTempColumnName(columnNames[columnKey]);
//   };

//   // Function to save column name
//   const handleSaveColumnName = (columnKey) => {
//     if (tempColumnName.trim() !== "") {
//       setColumnNames({
//         ...columnNames,
//         [columnKey]: tempColumnName
//       });
//     }
//     setIsEditingColumnName(null);
//     setTempColumnName("");
//   };

//   // Function to cancel editing
//   const handleCancelEdit = () => {
//     setIsEditingColumnName(null);
//     setTempColumnName("");
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const responseDetails = await axios.get(
//           apiUrl + `/invoicedetails/${invoice_id}`
//         );
//         const invoiceDetails = responseDetails.data[0];
//         setInvoiceDetails(invoiceDetails);
//         setSelectedClient(invoiceDetails.clientId);
//         setinvoicedetailsId(invoiceDetails.id);
//         setData({
//           invoiceId: invoiceDetails.invoiceId,
//           date: invoiceDetails.date,
//           dueDate: invoiceDetails.dueDate,
//           notes: invoiceDetails.notes,
//           totalTax: invoiceDetails.totalTax,
//           paymentStatus: invoiceDetails.paymentStatus,
//           totalAmount: invoiceDetails.totalAmount,
//           paymentDate: invoiceDetails.paymentDate,
//         });

//         const responseList = await axios.get(
//           apiUrl + `/invoicelist/${invoice_id}`
//         );
//         // Ensure every row has quantity (default 1) and all column fields
//         const formattedData = responseList.data.map((item) => ({
//           ...item,
//           // quantity: item.quantity || 1,
//           standard: item.standard || "",
//           premier: item.premier || "",
//           twilight: item.twilight || "",
//           day_to_dusk: item.day_to_dusk || "",
//           vra: item.vra || "",
//           vr: item.vr || "",
//           col7: item.col7 || "",
//           col8: item.col8 || "",
//           col9: item.col9 || "",
//           col10: item.col10 || "",
//           col11: item.col11 || "",
//           col12: item.col12 || "",
//         }));
//         setTableData(formattedData);

//         // Determine which columns have data
//         const dynamicColumns = ['col7', 'col8', 'col9', 'col10', 'col11', 'col12'];
//         let maxVisibleCol = 0;
//         dynamicColumns.forEach((col, idx) => {
//           const hasData = formattedData.some(item =>
//             item[col] && item[col].toString().trim() !== '' && parseFloat(item[col] || 0) !== 0
//           );
//           if (hasData) {
//             maxVisibleCol = idx + 1;
//           }
//         });
//         setVisibleColumns(maxVisibleCol);

//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     };
//     fetchData();
//   }, [invoice_id]);

//   const [ClientDetails, setClientDetails] = useState([]);
//   const clientdetails = async () => {
//     try {
//       const response = await axios.get(apiUrl + "/clientdetails");
//       if (response) setClientDetails(response.data);
//     } catch (error) {
//       console.error("Error fetching client details:", error);
//     }
//   };

//   useEffect(() => {
//     clientdetails();
//     categorytype();

//     const fetchExchangeRate = async () => {
//       try {
//         const response = await fetch(
//           "https://api.frankfurter.app/latest?from=USD&to=INR"
//         );
//         const data = await response.json();
//         setExchangeRate(data.rates.INR || 83);
//       } catch (error) {
//         setExchangeRate(83);
//       }
//     };
//     fetchExchangeRate();
//   }, []);

//   const [currentDate] = useState(getFormattedDate());
//   const [tableData, setTableData] = useState([]);
//   const [subtotal, setSubtotal] = useState(0);
//   const [tax, setTax] = useState(0);
//   const [netTotal, setNetTotal] = useState(0);
//   const [clientRowCreated, setClientRowCreated] = useState(false);
//   const [storedNetTotal, setStoredNetTotal] = useState(0);

//   function filter() {
//     const client = ClientDetails.find((data) => data.id === selectedClient);
//     if (client) {
//       setclientName(client.clientName);
//       setclientaddress(client.address);
//       setclientcountry(client.countrycode);
//       setclientmobile(client.mobile);
//     }
//   }

//   useEffect(() => {
//     if (ClientDetails.length > 0 && selectedClient) filter();
//   }, [ClientDetails, selectedClient]);

//   const handlerowadd = (e) => {
//     e.preventDefault();
//     const newId = Date.now();
//     const newRow = {
//       id: newId,
//       date: getFormattedDate(),
//       projectName: "",
//       standard: "",
//       premier: "",
//       twilight: "",
//       day_to_dusk: "",
//       vra: "",
//       vr: "",
//       col7: "",
//       col8: "",
//       col9: "",
//       col10: "",
//       col11: "",
//       col12: "",
//       // type: "",
//       // quantity: 1,
//       price: 0,
//       tax: "",
//       amount: "",
//       rate: "",
//     };
//     setTableData((prev) => [...prev, newRow]);
//     setClientRowCreated(true);
//   };

//   const handleTypeChange = (index, value) => {
//     if (!value) return;
//     setTableData((prev) => {
//       const updated = [...prev];
//       updated[index].type = value;

//       const cat = getCategoryType.find((item) => item.type === value);
//       if (cat) {
//         updated[index].price =
//           getclientcountry === "91" ? cat.INRprice : cat.price;
//       }
//       return updated;
//     });
//   };

//   const handleUserInputChange = (index, property, value) => {
//     console.log("handleUserInputChange triggered:", index, property, value);
//     setTableData((prev) => {
//       const updated = [...prev];
//       updated[index][property] = value;
//       return updated;
//     });
//   };

//   useEffect(() => {
//     let sub = 0,
//       tx = 0;
//     tableData.forEach((item) => {
//       // const qty = parseFloat(item.quantity) || 1;
//       const price = parseFloat(item.price) || 0;
//       const taxRate = parseFloat(item.tax) || 0;
//       const lineTotal =price;
//       sub += lineTotal;
//       tx += (lineTotal * taxRate) / 100;
//     });
//     setSubtotal(sub);
//     setTax(tx);
//     setNetTotal(sub + tx);
//   }, [tableData]);

//   useEffect(() => {
//     let finalAmount = 0;

//     if (getclientcountry === "91") {
//       finalAmount = netTotal * exchangeRate;
//     } else {
//       finalAmount = netTotal;
//     }

//     setStoredNetTotal(finalAmount);
//   }, [netTotal, getclientcountry, exchangeRate]);

//   const [deleteids, setDeleteIds] = useState([]);
//   const tablerowdelete = (id) => {
//     setTableData((prev) => prev.filter((item) => item.id !== id));
//     if (typeof id === "number" && id < 1000000) {
//       setDeleteIds((prev) => [...prev, id]);
//     }
//   };

//   const handleClearAll = () => {
//     setTableData([]);
//     setClientRowCreated(false);
//   };

//   const handleback = () => navigate("/invoice");

//   const [getCategoryType, setCategoryType] = useState([]);
//   const categorytype = async () => {
//     try {
//       const response = await axios.get(apiUrl + "/category");
//       setCategoryType(response.data || []);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   function getFormattedDate() {
//     const today = new Date();
//     const year = today.getFullYear();
//     let month = today.getMonth() + 1;
//     let day = today.getDate();
//     month = month < 10 ? `0${month}` : month;
//     day = day < 10 ? `0${day}` : day;
//     return `${year}-${month}-${day}`;
//   }

//   const validateForm = () => {
//     const empty = [];
//     if (!selectedClient) empty.push("Client Name");
//     if (!getData.date) empty.push("Date");
//     if (!getData.dueDate) empty.push("Due Date");

//     tableData.forEach((item, i) => {
//       // Check for projectName instead of type
//       if (item.projectName && item.projectName.trim() !== "") {
//         if (!item.tax || item.tax === "") empty.push(`Tax at row ${i + 1}`);
//         if (!item.quantity || item.quantity === "") empty.push(`Quantity at row ${i + 1}`);
//         if (!item.price || item.price === "") empty.push(`Price at row ${i + 1}`);
//       }
//     });

//     if (empty.length > 0) {
//       alert(`Please fill: ${empty.join(", ")}`);
//       return false;
//     }
//     return true;
//   };

//   const [isDataSubmitted, setIsDataSubmitted] = useState(false);
//   const [getData, setData] = useState({
//     invoiceId: "",
//     clientName: "",
//     date: "",
//     dueDate: "",
//     notes: "",
//     totalTax: "",
//     paymentStatus: "Unpaid",
//     totalAmount: "",
//     paymentDate: "",
//   });

//   const toaster = (cb) =>
//     toast.success("Updated successfully!", { autoClose: 1000, onClose: cb });

//   // const submitdata = async () => {
//   //   if (isDataSubmitted || !validateForm()) return;
//   //   setIsDataSubmitted(true);

//   //   try {
//   //     // Filter rows that have projectName instead of type
//   //     // const filtered = tableData.filter(
//   //     //   (item) => item.projectName && item.projectName.trim() !== ""
//   //     // );
//   //     const filtered = tableData
//   //     console.log("FILTERED TABLE DATA:", filtered);

//   //     const mainUpdate = {
//   //       invoiceId: invoice_id,
//   //       clientName: selectedClient,
//   //       date: getData.date,
//   //       dueDate: getData.dueDate,
//   //       totalAmount: netTotal.toFixed(2),
//   //       notes: getData.notes,
//   //       totalTax: tax.toFixed(2),
//   //       paymentStatus: "Unpaid",
//   //       paymentDate: "",
//   //     };

//   //     await axios.put(`${apiUrl}/invoicedetailsupdate/${invoicedetailsId}`, {
//   //       ...getData,
//   //       ...mainUpdate,
//   //     });

//   //     // Delete removed rows
//   //     for (const id of deleteids) {
//   //       await axios.delete(`${apiUrl}/invoicelist/${id}`);
//   //     }
//   //     setDeleteIds([]);

//   //     // Prepare list data
//   //     const listData = filtered.map((data) => {
//   //       const qty = parseFloat(data.quantity) || 1;
//   //       const price = parseFloat(data.price) || 0;
//   //       const taxRate = parseFloat(data.tax) || 0;

//   //       const rateUSD = (price * (1 + taxRate / 100)).toFixed(2);
//   //       const amountINR = (price * exchangeRate * (1 + taxRate / 100)).toFixed(2);
//   //       const totalAmt = (qty * price * (1 + taxRate / 100)).toFixed(2);

//   //       // Check if this is a new row (timestamp ID > 1000000000000)
//   //       const isNewRow = data.id > 1000000000000;

//   //       return {
//   //         id: isNewRow ? null : data.id, // Send null for new rows
//   //         invoiceId: invoice_id,
//   //         date: data.date || getFormattedDate(),
//   //         clientName: selectedClient,
//   //         projectName: data.projectName || "",
//   //         standard: data.standard || "",
//   //         premier: data.premier || "",
//   //         twilight: data.twilight || "",
//   //         day_to_dusk: data.day_to_dusk || "",
//   //         vra: data.vra || "",
//   //         vr: data.vr || "",
//   //         col7: data.col7 || "",
//   //         col8: data.col8 || "",
//   //         col9: data.col9 || "",
//   //         col10: data.col10 || "",
//   //         col11: data.col11 || "",
//   //         col12: data.col12 || "",
//   //         type: data.type || "",
//   //         quantity: qty,
//   //         price: price.toString(),
//   //         tax: taxRate.toString(),
//   //         amount: data.amount || amountINR,
//   //         rate: data.rate || rateUSD,
//   //         totalAmount: totalAmt,
//   //       };
//   //     });

//   //     console.log("DATA BEING SENT TO BACKEND:", JSON.stringify(listData, null, 2));
//   //     await axios.post(apiUrl + "/invoicelistupdate", listData);

//   //     toaster(() => navigate("/invoice"));
//   //   } catch (err) {
//   //     console.error(err);
//   //     toast.error("Update failed");
//   //     setIsDataSubmitted(false);
//   //   }
//   // };

//   const submitdata = async () => {
//     if (isDataSubmitted || !validateForm()) return;
//     setIsDataSubmitted(true);

//     try {
//       const filtered = tableData;

//       // ... (mainUpdate code stays the same) ...

//       // Delete removed rows
//       for (const id of deleteids) {
//         await axios.delete(`${apiUrl}/invoicelist/${id}`);
//       }
//       setDeleteIds([]);

//       // Prepare list data
//       const listData = filtered.map((data) => {
//         // const qty = parseFloat(data.quantity) || 1;
//         const price = parseFloat(data.price) || 0;
//         const taxRate = parseFloat(data.tax) || 0;

//         const rateUSD = (price * (1 + taxRate / 100)).toFixed(2);
//         const amountINR = (price * exchangeRate * (1 + taxRate / 100)).toFixed(2);
//         const totalAmt = ( price * (1 + taxRate / 100)).toFixed(2);

//         const isNewRow = data.id > 100000000000;

//         const rowData = {
//           invoiceId: invoice_id,
//           date: data.date || getFormattedDate(),
//           clientName: selectedClient,
//           projectName: data.projectName || "",
//           standard: data.standard || "",
//           premier: data.premier || "",
//           twilight: data.twilight || "",
//           day_to_dusk: data.day_to_dusk || "",
//           vra: data.vra || "",
//           vr: data.vr || "",
//           col7: data.col7 || "",
//           col8: data.col8 || "",
//           col9: data.col9 || "",
//           col10: data.col10 || "",
//           col11: data.col11 || "",
//           col12: data.col12 || "",
//           // type: data.type || "",
//           // quantity: qty,
//           price: price.toString(),
//           tax: taxRate.toString(),
//           amount: data.amount || amountINR,
//           rate: data.rate || rateUSD,
//           totalAmount: totalAmt,
//         };

//         // Don't include id for new rows
//         if (!isNewRow) {
//           rowData.id = data.id;
//         }

//         return rowData;
//       });

//       console.log("DATA BEING SENT TO BACKEND:", JSON.stringify(listData, null, 2));
//       await axios.post(apiUrl + "/invoicelistupdate", listData);

//       toaster(() => navigate("/invoice"));
//     } catch (err) {
//       console.error(err);
//       toast.error("Update failed");
//       setIsDataSubmitted(false);
//     }
//   };

//   const handlenavigate = async () => {
//     const isValid = validateForm();
//     if (isValid) {
//       try {
//         await submitdata();
//         // Small delay to ensure data is saved
//         setTimeout(() => {
//           navigate(`/invoice/invoiceprint/${invoice_id}`);
//         }, 1000);
//       } catch (error) {
//         console.error("Error submitting data and navigating:", error);
//       }
//     }
//   };

//   // Map column keys to their display order
//   const columnOrder = ['col7', 'col8', 'col9', 'col10', 'col11', 'col12'];

//   return (
//     <>
//       <ToastContainer />
//       <h3 className="text-center">Edit Invoice</h3>
//       <hr />
//       <div className="mx-1">
//         <div className="invoicebackground1">
//           <form className="row">
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <label className="form-label">Invoice No.</label>
//               <input
//                 className="form-control"
//                 value={invoice_id}
//                 type="text"
//                 readOnly
//               ></input>
//             </div>
//             <div className="col-lg-6 col-md-4"></div>
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <label className="form-label">Date :</label>
//               <input
//                 className="form-control"
//                 type="date"
//                 value={getData.date || ""}
//                 onChange={(e) => setData({ ...getData, date: e.target.value })}
//                 required
//               />
//             </div>
//           </form>
//         </div>

//         <div className="invoicebackground1">
//           <form className="row">
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <div className="dropdown">
//                 <label className="form-label">Client Name :</label>
//                 <div className="position-relative">
//                   <select
//                     className="form-control dropdown-toggle custom-select"
//                     value={selectedClient}
//                     disabled
//                   >
//                     <option value="">{getclientName}</option>
//                   </select>
//                   <div className="dropdown-arrow"></div>
//                 </div>
//               </div>
//             </div>
//             <div className="col-lg-3 col-md-4">
//               <div className="mt-4 d-flex gap-2">
//                 {/* Add Row Button */}
//                 <button
//                   type="button"
//                   className="btn btn-success btn-sm mt-2"
//                   onClick={handlerowadd}
//                 >
//                   <i className="fa-solid fa-plus me-1"></i>
//                   Add Row
//                 </button>
//                 {/* Add Column Button */}
//                 {visibleColumns < 6 && (
//                   <button
//                     type="button"
//                     className="btn btn-primary btn-sm mt-2"
//                     onClick={handleAddColumn}
//                   >
//                     <i className="fa-solid fa-plus me-1"></i>
//                     Add Column
//                   </button>
//                 )}
//               </div>
//             </div>
//             <div className="col-lg-3"></div>
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <form className="control">
//                 <label className="form-label">Due Date</label>
//                 <input
//                   className="form-control"
//                   value={getData.dueDate || ""}
//                   type="date"
//                   onChange={(e) =>
//                     setData({ ...getData, dueDate: e.target.value })
//                   }
//                   required
//                 />
//               </form>
//             </div>
//           </form>
//         </div>

//         <div className="invoicebackground1">
//           <div className="table-responsive">
//             <table className="table table-bordered">
//               <thead className="font-size">
//                 <tr>
//                   <th>S.No</th>
//                   <th style={{ width: "0%" }}>Date</th>
//                   <th style={{ width: "15%" }}>Address</th>
//                   <th style={{ width: "4%" }}>Standard</th>
//                   <th style={{ width: "4%" }}>Primier</th>
//                   <th style={{ width: "4%" }}>Twilight</th>
//                   <th style={{ width: "7%" }}>Day to Dust</th>
//                   <th style={{ width: "4%" }}>VRA(5$)</th>
//                   <th style={{ width: "4%" }}>VR(12$)</th>

//                   {/* Dynamic columns */}
//                   {columnOrder.slice(0, visibleColumns).map((colKey, idx) => (
//                     <th key={colKey} style={{ width: "4%" }}>
//                       {isEditingColumnName === colKey ? (
//                         <div className="d-flex align-items-center gap-1">
//                           <input
//                             type="text"
//                             className="form-control form-control-sm"
//                             value={tempColumnName}
//                             onChange={(e) => setTempColumnName(e.target.value)}
//                             onKeyPress={(e) => {
//                               if (e.key === 'Enter') {
//                                 handleSaveColumnName(colKey);
//                               }
//                             }}
//                             autoFocus
//                           />
//                           <button
//                             className="btn btn-success btn-sm p-1"
//                             onClick={() => handleSaveColumnName(colKey)}
//                           >
//                             <i className="fa-solid fa-check"></i>
//                           </button>
//                           <button
//                             className="btn btn-danger btn-sm p-1"
//                             onClick={handleCancelEdit}
//                           >
//                             <i className="fa-solid fa-times"></i>
//                           </button>
//                         </div>
//                       ) : (
//                         <div
//                           className="d-flex align-items-center justify-content-between"
//                           style={{ cursor: 'pointer' }}
//                           onClick={() => handleEditColumnName(colKey)}
//                         >
//                           <span>{columnNames[colKey]}</span>
//                           <i className="fa-solid fa-edit ms-1" style={{ fontSize: '12px' }}></i>
//                         </div>
//                       )}
//                     </th>
//                   ))}

//                   <th style={{ width: "5%" }}>$ Price</th>
//                   <th style={{ width: "5%" }}>Tax</th>
//                   <th style={{ width: "7%" }}>₹ Amount</th>
//                   <th style={{ width: "7%" }}>$ Rate</th>
//                   <th>Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {tableData.map((item, index) => (
//                   <tr key={item.id}>
//                     <th scope="row">{index + 1}</th>
//                     <td>
//                       <input
//                         style={{ width: "80%" }}
//                         className="form-control pe-0"
//                         type="date"
//                         value={item.date || ""}
//                         onChange={(e) =>
//                           handleUserInputChange(index, "date", e.target.value)
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         style={{ width: "100%" }}
//                         className="form-control"
//                         type="text"
//                         value={item.projectName || ""}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "projectName",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.standard || ""}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "standard",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.premier || ""}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "premier",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.twilight || ""}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "twilight",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.day_to_dusk || ""}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "day_to_dusk",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.vra || ""}
//                         onChange={(e) =>
//                           handleUserInputChange(index, "vra", e.target.value)
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.vr || ""}
//                         onChange={(e) =>
//                           handleUserInputChange(index, "vr", e.target.value)
//                         }
//                       />
//                     </td>

//                     {/* Dynamic column inputs */}
//                     {columnOrder.slice(0, visibleColumns).map((colKey) => (
//                       <td key={colKey}>
//                         <input
//                           className="form-control"
//                           type="text"
//                           value={item[colKey] || ""}
//                           onChange={(e) =>
//                             handleUserInputChange(index, colKey, e.target.value)
//                           }
//                         />
//                       </td>
//                     ))}

//                     <td>
//                       <input
//                         className="form-control"
//                         type="tel"
//                         value={item.price || ""}
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           const onlyNumbers = value.replace(/[^0-9]/g, "");
//                           handleUserInputChange(index, "price", onlyNumbers);
//                         }}
//                       />
//                     </td>

//                     <td>
//                       <input
//                         className="form-control"
//                         type="tel"
//                         value={item.tax || ""}
//                         placeholder="Tax"
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           const onlyNumbers = value.replace(/[^0-9]/g, "");
//                           handleUserInputChange(index, "tax", onlyNumbers);
//                         }}
//                       />
//                     </td>

//                     <td>
//                       <input
//                         type="text"
//                         className="form-control ps-2"
//                         value={
//                           item.amount !== undefined && item.amount !== ""
//                             ? item.amount
//                             : (
//                               parseFloat(item.price * exchangeRate) +
//                               parseFloat(
//                                 (item.price * exchangeRate * item.tax) / 100
//                               )
//                             ).toFixed(2)
//                         }
//                         onChange={(e) => {
//                           const value = e.target.value.replace(/[^0-9.]/g, "");
//                           handleUserInputChange(index, "amount", value);
//                         }}
//                       />
//                     </td>

//                     <td>
//                       <input
//                         className="form-control ps-2"
//                         placeholder="rate"
//                         value={
//                           item.rate !== undefined && item.rate !== ""
//                             ? item.rate
//                             : (
//                               parseFloat(item.price * item.tax) / 100 +
//                               parseFloat(item.price)
//                             ).toFixed(2)
//                         }
//                         onChange={(e) => {
//                           const value = e.target.value.replace(/[^0-9.]/g, "");
//                           handleUserInputChange(index, "rate", value);
//                         }}
//                       />
//                     </td>

//                     <td>
//                       <button
//                         className="btn btn-danger px-1 py-1 d-flex align-items-center"
//                         onClick={() => tablerowdelete(item.id)}
//                       >
//                         <i className="fa-solid fa-trash"></i>
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           <div className="row mt-4">
//             <div className="col-lg-6 col-md-6 col-sm-12">
//               <label className="form-label">
//                 <b>Notes :</b>
//                 <br />
//                 <textarea
//                   className="form-control notes-textarea"
//                   type="text"
//                   value={getData.notes || ""}
//                   onChange={(e) => {
//                     setData({ ...getData, notes: e.target.value });
//                   }}
//                   required
//                 />
//               </label>
//             </div>
//             <div className="col-lg-6 col-md-6 col-sm-12">
//               <form>
//                 <div className="row">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Sub Total</b>
//                     </label>
//                   </div>
//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${subtotal.toFixed(2)}`
//                           : `${subtotal.toFixed(2)}`
//                       }
//                       type="text"
//                       placeholder="Sub Total"
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="row mt-3">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Paypal Tax</b>
//                     </label>
//                   </div>
//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${tax.toFixed(2)}`
//                           : `${tax.toFixed(2)}`
//                       }
//                       type="text"
//                       placeholder="Tax"
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="row mt-3">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Net Total</b>
//                     </label>
//                   </div>
//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${Math.round(storedNetTotal).toFixed(2)}`
//                           : `${Math.round(storedNetTotal).toFixed(2)}`
//                       }
//                       type="text"
//                       placeholder="Net Total"
//                       readOnly
//                     />
//                   </div>
//                 </div>
//               </form>
//             </div>
//           </div>

//           <div className="row">
//             <div className="col-lg-5"></div>
//             <div className="col-lg-7">
//               <div
//                 style={{ marginLeft: "75px" }}
//                 className="d-flex justify-content-evenly mt-3 buttonstyle"
//               >
//                 <button
//                   type="button"
//                   className="btn btn-danger invoice-button"
//                   onClick={handleClearAll}
//                 >
//                   Clear
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-info text-white invoice-button"
//                   style={{ backgroundColor: "#007BFF" }}
//                   onClick={handleback}
//                 >
//                   Back
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-success invoice-button"
//                   onClick={submitdata}
//                 >
//                   Update
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-secondary invoice-button"
//                   onClick={handlenavigate}
//                 >
//                   Print
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default InvoiceUpdate;

// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import apiUrl from "../../Environment/Api";
// import { useNavigate, useParams } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const useForceUpdate = () => {
//   const [, forceUpdate] = useState();
//   return useCallback(() => forceUpdate((prev) => !prev), []);
// };

// function InvoiceUpdate() {
//   const forceUpdate = useForceUpdate();
//   const navigate = useNavigate();
//   const [exchangeRate, setExchangeRate] = useState("");

//   const { invoice_id } = useParams();
//   console.log("edit id", invoice_id);

//   const [invoiceData, setInvoiceDetails] = useState({});
//   const [getclientaddress, setclientaddress] = useState("");
//   const [getclientcountry, setclientcountry] = useState("");
//   const [getclientmobile, setclientmobile] = useState("");
//   const [getclientName, setclientName] = useState("");
//   const [selectedClient, setSelectedClient] = useState("");
//   const [invoicedetailsId, setinvoicedetailsId] = useState("");

//   // State for dynamic columns - changed to array like Invoiceadd
//   const [visibleColumns, setVisibleColumns] = useState([]);
//   const [columnNames, setColumnNames] = useState({
//     standard: "Standard",
//     premier: "Premier",
//     twilight: "Twilight",
//     day_to_dusk: "Day to Dusk",
//     vra: "VRA(5$)",
//     vr: "VR(12$)",
//     col7: "Column 7",
//     col8: "Column 8",
//     col9: "Column 9",
//     col10: "Column 10",
//     col11: "Column 11",
//     col12: "Column 12"
//   });

//   // Modal state (like in Invoiceadd)
//   const [showModal, setShowModal] = useState(false);
//   const [pendingColumnKey, setPendingColumnKey] = useState(null);
//   const [modalColumnName, setModalColumnName] = useState("");
//   const [isEditMode, setIsEditMode] = useState(false);

//   // Column order - all columns in sequence
//   const columnOrder = ['standard', 'premier', 'twilight', 'day_to_dusk', 'vra', 'vr', 'col7', 'col8', 'col9', 'col10', 'col11', 'col12'];

//   // Function to add a new column - opens modal
//   const handleAddColumn = () => {
//     const availableColumns = columnOrder.filter(col => !visibleColumns.includes(col));
//     if (availableColumns.length > 0) {
//       const nextColumnKey = availableColumns[0];
//       setPendingColumnKey(nextColumnKey);
//       setModalColumnName(columnNames[nextColumnKey]);
//       setIsEditMode(false);
//       setShowModal(true);
//     }
//   };

//   // Function to edit existing column name - opens modal
//   const handleEditColumn = (columnKey) => {
//     setPendingColumnKey(columnKey);
//     setModalColumnName(columnNames[columnKey]);
//     setIsEditMode(true);
//     setShowModal(true);
//   };

//   // Function to remove a column
//   const handleRemoveColumn = (columnKey) => {
//     if (window.confirm(`Are you sure you want to remove the "${columnNames[columnKey]}" column? This will clear all data in this column.`)) {
//       // Remove from visible columns
//       setVisibleColumns(visibleColumns.filter(col => col !== columnKey));

//       // Clear data from all rows for this column
//       const updatedTableData = tableData.map(row => ({
//         ...row,
//         [columnKey]: ""
//       }));
//       setTableData(updatedTableData);
//     }
//   };

//   // Handle modal save
//   const handleModalSave = () => {
//     if (modalColumnName.trim() !== "" && pendingColumnKey) {
//       // Update column name
//       setColumnNames({
//         ...columnNames,
//         [pendingColumnKey]: modalColumnName
//       });

//       // Only add to visible columns if we're adding a new column
//       if (!isEditMode) {
//         setVisibleColumns([...visibleColumns, pendingColumnKey]);
//       }

//       // Close modal
//       setShowModal(false);
//       setModalColumnName("");
//       setPendingColumnKey(null);
//       setIsEditMode(false);
//     } else {
//       alert("Please enter a column name");
//     }
//   };

//   // Handle modal cancel
//   const handleModalCancel = () => {
//     setShowModal(false);
//     setModalColumnName("");
//     setPendingColumnKey(null);
//     setIsEditMode(false);
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const responseDetails = await axios.get(
//           apiUrl + `/invoicedetails/${invoice_id}`
//         );
//         const invoiceDetails = responseDetails.data[0];
//         setInvoiceDetails(invoiceDetails);
//         setSelectedClient(invoiceDetails.clientId);
//         setinvoicedetailsId(invoiceDetails.id);
//         setData({
//           invoiceId: invoiceDetails.invoiceId,
//           date: invoiceDetails.date,
//           dueDate: invoiceDetails.dueDate,
//           notes: invoiceDetails.notes,
//           totalTax: invoiceDetails.totalTax,
//           paymentStatus: invoiceDetails.paymentStatus,
//           totalAmount: invoiceDetails.totalAmount,
//           paymentDate: invoiceDetails.paymentDate,
//         });

//         // **NEW: Load column configuration**
//         try {
//           const columnResponse = await axios.get(
//             apiUrl + `/invoice-columns/${invoice_id}`
//           );

//           if (columnResponse.data.status === 'success' && columnResponse.data.data) {
//             const savedColumns = columnResponse.data.data;

//             // Update column names with saved values
//             setColumnNames({
//               standard: savedColumns.standard || "Standard",
//               premier: savedColumns.premier || "Premier",
//               twilight: savedColumns.twilight || "Twilight",
//               day_to_dusk: savedColumns.day_to_dusk || "Day to Dusk",
//               vra: savedColumns.vra || "VRA(5$)",
//               vr: savedColumns.vr || "VR(12$)",
//               col7: savedColumns.col7 || "Column 7",
//               col8: savedColumns.col8 || "Column 8",
//               col9: savedColumns.col9 || "Column 9",
//               col10: savedColumns.col10 || "Column 10",
//               col11: savedColumns.col11 || "Column 11",
//               col12: savedColumns.col12 || "Column 12"
//             });
//           }
//         } catch (err) {
//           console.error("Error loading column configuration:", err);
//         }

//         const responseList = await axios.get(
//           apiUrl + `/invoicelist/${invoice_id}`
//         );

//         const formattedData = responseList.data.map((item) => ({
//           ...item,
//           quantity: item.quantity || 1,
//           standard: item.standard || "",
//           premier: item.premier || "",
//           twilight: item.twilight || "",
//           day_to_dusk: item.day_to_dusk || "",
//           vra: item.vra || "",
//           vr: item.vr || "",
//           col7: item.col7 || "",
//           col8: item.col8 || "",
//           col9: item.col9 || "",
//           col10: item.col10 || "",
//           col11: item.col11 || "",
//           col12: item.col12 || "",
//         }));
//         setTableData(formattedData);

//         // Determine visible columns
//         const allColumns = ['standard', 'premier', 'twilight', 'day_to_dusk', 'vra', 'vr', 'col7', 'col8', 'col9', 'col10', 'col11', 'col12'];
//         const visibleCols = [];

//         allColumns.forEach((col) => {
//           const hasData = formattedData.some(item =>
//             item[col] && item[col].toString().trim() !== '' && parseFloat(item[col] || 0) !== 0
//           );
//           if (hasData) {
//             visibleCols.push(col);
//           }
//         });

//         setVisibleColumns(visibleCols);

//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     };
//     fetchData();
//   }, [invoice_id]);

//   const [ClientDetails, setClientDetails] = useState([]);
//   const clientdetails = async () => {
//     try {
//       const response = await axios.get(apiUrl + "/clientdetails");
//       if (response) setClientDetails(response.data);
//     } catch (error) {
//       console.error("Error fetching client details:", error);
//     }
//   };

//   useEffect(() => {
//     clientdetails();
//     categorytype();

//     const fetchExchangeRate = async () => {
//       try {
//         const response = await fetch(
//           "https://api.frankfurter.app/latest?from=USD&to=INR"
//         );
//         const data = await response.json();
//         setExchangeRate(data.rates.INR || 83);
//       } catch (error) {
//         setExchangeRate(83);
//       }
//     };
//     fetchExchangeRate();
//   }, []);

//   const [currentDate] = useState(getFormattedDate());
//   const [tableData, setTableData] = useState([]);
//   const [subtotal, setSubtotal] = useState(0);
//   const [tax, setTax] = useState(0);
//   const [netTotal, setNetTotal] = useState(0);
//   const [clientRowCreated, setClientRowCreated] = useState(false);
//   const [storedNetTotal, setStoredNetTotal] = useState(0);

//   function filter() {
//     const client = ClientDetails.find((data) => data.id === selectedClient);
//     if (client) {
//       setclientName(client.clientName);
//       setclientaddress(client.address);
//       setclientcountry(client.countrycode);
//       setclientmobile(client.mobile);
//     }
//   }

//   useEffect(() => {
//     if (ClientDetails.length > 0 && selectedClient) filter();
//   }, [ClientDetails, selectedClient]);

//   const handlerowadd = (e) => {
//     e.preventDefault();
//     const newId = Date.now();
//     const newRow = {
//       id: newId,
//       date: getFormattedDate(),
//       projectName: "",
//       standard: "",
//       premier: "",
//       twilight: "",
//       day_to_dusk: "",
//       vra: "",
//       vr: "",
//       col7: "",
//       col8: "",
//       col9: "",
//       col10: "",
//       col11: "",
//       col12: "",
//       type: "",
//       quantity: 1,
//       price: 0,
//       tax: "",
//       amount: "",
//       rate: "",
//     };
//     setTableData((prev) => [...prev, newRow]);
//     setClientRowCreated(true);
//   };

//   const handleTypeChange = (index, value) => {
//     if (!value) return;
//     setTableData((prev) => {
//       const updated = [...prev];
//       updated[index].type = value;

//       const cat = getCategoryType.find((item) => item.type === value);
//       if (cat) {
//         updated[index].price =
//           getclientcountry === "91" ? cat.INRprice : cat.price;
//       }
//       return updated;
//     });
//   };

//   const handleUserInputChange = (index, property, value) => {
//     console.log("handleUserInputChange triggered:", index, property, value);
//     setTableData((prev) => {
//       const updated = [...prev];
//       updated[index][property] = value;
//       return updated;
//     });
//   };

//   useEffect(() => {
//     let sub = 0,
//       tx = 0;
//     tableData.forEach((item) => {
//       const qty = parseFloat(item.quantity) || 1;
//       const price = parseFloat(item.price) || 0;
//       const taxRate = parseFloat(item.tax) || 0;
//       const lineTotal = qty * price;
//       sub += lineTotal;
//       tx += (lineTotal * taxRate) / 100;
//     });
//     setSubtotal(sub);
//     setTax(tx);
//     setNetTotal(sub + tx);
//   }, [tableData]);

//   useEffect(() => {
//     let finalAmount = 0;

//     if (getclientcountry === "91") {
//       finalAmount = netTotal * exchangeRate;
//     } else {
//       finalAmount = netTotal;
//     }

//     setStoredNetTotal(finalAmount);
//   }, [netTotal, getclientcountry, exchangeRate]);

//   const [deleteids, setDeleteIds] = useState([]);
//   const tablerowdelete = (id) => {
//     setTableData((prev) => prev.filter((item) => item.id !== id));
//     if (typeof id === "number" && id < 1000000) {
//       setDeleteIds((prev) => [...prev, id]);
//     }
//   };

//   const handleClearAll = () => {
//     setTableData([]);
//     setClientRowCreated(false);
//   };

//   const handleback = () => navigate("/invoice");

//   const [getCategoryType, setCategoryType] = useState([]);
//   const categorytype = async () => {
//     try {
//       const response = await axios.get(apiUrl + "/category");
//       setCategoryType(response.data || []);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   function getFormattedDate() {
//     const today = new Date();
//     const year = today.getFullYear();
//     let month = today.getMonth() + 1;
//     let day = today.getDate();
//     month = month < 10 ? `0${month}` : month;
//     day = day < 10 ? `0${day}` : day;
//     return `${year}-${month}-${day}`;
//   }

//   const validateForm = () => {
//     const empty = [];
//     if (!selectedClient) empty.push("Client Name");
//     if (!getData.date) empty.push("Date");
//     if (!getData.dueDate) empty.push("Due Date");

//     tableData.forEach((item, i) => {
//       // Check for projectName instead of type
//       if (item.projectName && item.projectName.trim() !== "") {
//         if (!item.tax || item.tax === "") empty.push(`Tax at row ${i + 1}`);
//         if (!item.quantity || item.quantity === "") empty.push(`Quantity at row ${i + 1}`);
//         if (!item.price || item.price === "") empty.push(`Price at row ${i + 1}`);
//       }
//     });

//     if (empty.length > 0) {
//       alert(`Please fill: ${empty.join(", ")}`);
//       return false;
//     }
//     return true;
//   };

//   const [isDataSubmitted, setIsDataSubmitted] = useState(false);
//   const [getData, setData] = useState({
//     invoiceId: "",
//     clientName: "",
//     date: "",
//     dueDate: "",
//     notes: "",
//     totalTax: "",
//     paymentStatus: "Unpaid",
//     totalAmount: "",
//     paymentDate: "",
//   });

//   const toaster = (cb) =>
//     toast.success("Updated successfully!", { autoClose: 1000, onClose: cb });

//   const submitdata = async () => {
//     if (isDataSubmitted || !validateForm()) return;
//     setIsDataSubmitted(true);

//     try {
//       const filtered = tableData;

//       const mainUpdate = {
//         invoiceId: invoice_id,
//         clientName: selectedClient,
//         date: getData.date,
//         dueDate: getData.dueDate,
//         totalAmount: netTotal.toFixed(2),
//         notes: getData.notes,
//         totalTax: tax.toFixed(2),
//         paymentStatus: "Unpaid",
//         paymentDate: "",
//       };

//       await axios.put(`${apiUrl}/invoicedetailsupdate/${invoicedetailsId}`, {
//         ...getData,
//         ...mainUpdate,
//       });

//       // Update column configuration
//       const columnConfig = {
//         clientName: selectedClient,
//         ...columnNames
//       };

//       try {
//         await axios.put(apiUrl + `/invoice-columns/${invoice_id}`, columnConfig);
//         console.log("Column configuration updated");
//       } catch (err) {
//         console.error("Error updating column configuration:", err);
//       }

//       // Delete removed rows
//       for (const id of deleteids) {
//         await axios.delete(`${apiUrl}/invoicelist/${id}`);
//       }
//       setDeleteIds([]);

//       // **MISSING CODE - Prepare list data**
//       const listData = filtered.map((data) => {
//         const qty = parseFloat(data.quantity) || 1;
//         const price = parseFloat(data.price) || 0;
//         const taxRate = parseFloat(data.tax) || 0;

//         const rateUSD = (price * (1 + taxRate / 100)).toFixed(2);
//         const amountINR = (price * exchangeRate * (1 + taxRate / 100)).toFixed(2);
//         const totalAmt = (qty * price * (1 + taxRate / 100)).toFixed(2);

//         const isNewRow = data.id > 100000000000;

//         const rowData = {
//           invoiceId: invoice_id,
//           date: data.date || getFormattedDate(),
//           clientName: selectedClient,
//           projectName: data.projectName || "",
//           standard: data.standard || "",
//           premier: data.premier || "",
//           twilight: data.twilight || "",
//           day_to_dusk: data.day_to_dusk || "",
//           vra: data.vra || "",
//           vr: data.vr || "",
//           col7: data.col7 || "",
//           col8: data.col8 || "",
//           col9: data.col9 || "",
//           col10: data.col10 || "",
//           col11: data.col11 || "",
//           col12: data.col12 || "",
//           type: data.type || "",
//           quantity: qty,
//           price: price.toString(),
//           tax: taxRate.toString(),
//           amount: data.amount || amountINR,
//           rate: data.rate || rateUSD,
//           totalAmount: totalAmt,
//         };

//         // Don't include id for new rows
//         if (!isNewRow) {
//           rowData.id = data.id;
//         }

//         return rowData;
//       });

//       console.log("DATA BEING SENT TO BACKEND:", JSON.stringify(listData, null, 2));

//       // **MISSING CODE - Send the invoice list data**
//       await axios.post(apiUrl + "/invoicelistupdate", listData);

//       toaster(() => navigate("/invoice"));
//     } catch (err) {
//       console.error(err);
//       toast.error("Update failed");
//       setIsDataSubmitted(false);
//     }
//   };

//   const handlenavigate = async () => {
//     const isValid = validateForm();
//     if (isValid) {
//       try {
//         await submitdata();
//         // Small delay to ensure data is saved
//         setTimeout(() => {
//           navigate(`/invoice/invoiceprint/${invoice_id}`);
//         }, 1000);
//       } catch (error) {
//         console.error("Error submitting data and navigating:", error);
//       }
//     }
//   };

//   return (
//     <>
//       <ToastContainer />

//       {/* Modal for naming/editing columns (from Invoiceadd) */}
//       {showModal && (
//         <div
//           className="modal fade show"
//           style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
//           tabIndex="-1"
//         >
//           <div className="modal-dialog modal-dialog-centered">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h5 className="modal-title">
//                   {isEditMode ? 'Edit Column Name' : 'Name Your Column'}
//                 </h5>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   onClick={handleModalCancel}
//                 ></button>
//               </div>
//               <div className="modal-body">
//                 <label className="form-label">Column Name:</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   value={modalColumnName}
//                   onChange={(e) => setModalColumnName(e.target.value)}
//                   onKeyPress={(e) => {
//                     if (e.key === 'Enter') {
//                       handleModalSave();
//                     }
//                   }}
//                   placeholder="Enter column name"
//                   autoFocus
//                 />
//               </div>
//               <div className="modal-footer">
//                 <button
//                   type="button"
//                   className="btn btn-secondary"
//                   onClick={handleModalCancel}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-primary"
//                   onClick={handleModalSave}
//                 >
//                   Save
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       <h3 className="text-center">Edit Invoice</h3>
//       <hr />
//       <div className="mx-1">
//         <div className="invoicebackground1">
//           <form className="row">
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <label className="form-label">Invoice No.</label>
//               <input
//                 className="form-control"
//                 value={invoice_id}
//                 type="text"
//                 readOnly
//               ></input>
//             </div>
//             <div className="col-lg-6 col-md-4"></div>
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <label className="form-label">Date :</label>
//               <input
//                 className="form-control"
//                 type="date"
//                 value={getData.date || ""}
//                 onChange={(e) => setData({ ...getData, date: e.target.value })}
//                 required
//               />
//             </div>
//           </form>
//         </div>

//         <div className="invoicebackground1">
//           <form className="row">
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <div className="dropdown">
//                 <label className="form-label">Client Name :</label>
//                 <div className="position-relative">
//                   <select
//                     className="form-control dropdown-toggle custom-select"
//                     value={selectedClient}
//                     disabled
//                   >
//                     <option value="">{getclientName}</option>
//                   </select>
//                   <div className="dropdown-arrow"></div>
//                 </div>
//               </div>
//             </div>
//             <div className="col-lg-3 col-md-4">
//               <div className="mt-4">
//                 {/* Add Row Button */}
//                 <button
//                   type="button"
//                   className="btn btn-success btn-sm mt-2 me-2"
//                   onClick={handlerowadd}
//                 >
//                   <i className="fa-solid fa-plus me-1"></i>
//                   Add Row
//                 </button>
//                 {/* Add Column Button */}
//                 {visibleColumns.length < 12 && (
//                   <button
//                     type="button"
//                     className="btn btn-primary btn-sm mt-2"
//                     onClick={handleAddColumn}
//                   >
//                     <i className="fa-solid fa-plus me-1"></i>
//                     Add Column
//                   </button>
//                 )}
//               </div>
//             </div>
//             <div className="col-lg-3"></div>
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <form className="control">
//                 <label className="form-label">Due Date</label>
//                 <input
//                   className="form-control"
//                   value={getData.dueDate || ""}
//                   type="date"
//                   onChange={(e) =>
//                     setData({ ...getData, dueDate: e.target.value })
//                   }
//                   required
//                 />
//               </form>
//             </div>
//           </form>
//         </div>

//         <div className="invoicebackground1">
//           <div className="table-responsive">
//             <table className="table table-bordered">
//               <thead className="font-size">
//                 <tr>
//                   <th>S.No</th>
//                   <th style={{ width: "0%" }}>Date</th>
//                   <th style={{ width: "15%" }}>Address</th>

//                   {/* Dynamic columns - ALL columns after Address are now dynamic */}
//                   {visibleColumns.map((colKey) => (
//                     <th key={colKey} style={{ width: "4%" }}>
//                       <div
//                         className="d-flex align-items-center justify-content-between"
//                         style={{ gap: '5px' }}
//                       >
//                         <span
//                           style={{ cursor: 'pointer', flex: 1 }}
//                           onClick={() => handleEditColumn(colKey)}
//                           title="Click to edit column name"
//                         >
//                           {columnNames[colKey]}
//                         </span>
//                         <i
//                           className="fa-solid fa-edit"
//                           style={{ fontSize: '12px', cursor: 'pointer' }}
//                           onClick={() => handleEditColumn(colKey)}
//                           title="Edit column name"
//                         ></i>
//                         <i
//                           className="fa-solid fa-trash text-danger"
//                           style={{ fontSize: '12px', cursor: 'pointer' }}
//                           onClick={() => handleRemoveColumn(colKey)}
//                           title="Remove column"
//                         ></i>
//                       </div>
//                     </th>
//                   ))}

//                   <th style={{ width: "5%" }}>$ Price</th>
//                   <th style={{ width: "5%" }}>Tax</th>
//                   <th style={{ width: "7%" }}>₹ Amount</th>
//                   <th style={{ width: "7%" }}>$ Rate</th>
//                   <th>Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {tableData.map((item, index) => (
//                   <tr key={item.id}>
//                     <th scope="row">{index + 1}</th>
//                     <td>
//                       <input
//                         style={{ width: "80%" }}
//                         className="form-control pe-0"
//                         type="date"
//                         value={item.date || ""}
//                         onChange={(e) =>
//                           handleUserInputChange(index, "date", e.target.value)
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         style={{ width: "100%" }}
//                         className="form-control"
//                         type="text"
//                         value={item.projectName || ""}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "projectName",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>

//                     {/* Dynamic column inputs - render based on visible columns */}
//                     {visibleColumns.map((colKey) => (
//                       <td key={colKey}>
//                         <input
//                           className="form-control"
//                           type="text"
//                           value={item[colKey] || ""}
//                           onChange={(e) =>
//                             handleUserInputChange(index, colKey, e.target.value)
//                           }
//                         />
//                       </td>
//                     ))}

//                     <td>
//                       <input
//                         className="form-control"
//                         type="tel"
//                         value={item.price || ""}
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           const onlyNumbers = value.replace(/[^0-9]/g, "");
//                           handleUserInputChange(index, "price", onlyNumbers);
//                         }}
//                       />
//                     </td>

//                     <td>
//                       <input
//                         className="form-control"
//                         type="tel"
//                         value={item.tax || ""}
//                         placeholder="Tax"
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           const onlyNumbers = value.replace(/[^0-9]/g, "");
//                           handleUserInputChange(index, "tax", onlyNumbers);
//                         }}
//                       />
//                     </td>

//                     <td>
//                       <input
//                         type="text"
//                         className="form-control ps-2"
//                         value={
//                           item.amount !== undefined && item.amount !== ""
//                             ? item.amount
//                             : (
//                               parseFloat(item.price * exchangeRate) +
//                               parseFloat(
//                                 (item.price * exchangeRate * item.tax) / 100
//                               )
//                             ).toFixed(2)
//                         }
//                         onChange={(e) => {
//                           const value = e.target.value.replace(/[^0-9.]/g, "");
//                           handleUserInputChange(index, "amount", value);
//                         }}
//                       />
//                     </td>

//                     <td>
//                       <input
//                         className="form-control ps-2"
//                         placeholder="rate"
//                         value={
//                           item.rate !== undefined && item.rate !== ""
//                             ? item.rate
//                             : (
//                               parseFloat(item.price * item.tax) / 100 +
//                               parseFloat(item.price)
//                             ).toFixed(2)
//                         }
//                         onChange={(e) => {
//                           const value = e.target.value.replace(/[^0-9.]/g, "");
//                           handleUserInputChange(index, "rate", value);
//                         }}
//                       />
//                     </td>

//                     <td>
//                       <button
//                         className="btn btn-danger px-1 py-1 d-flex align-items-center"
//                         onClick={() => tablerowdelete(item.id)}
//                       >
//                         <i className="fa-solid fa-trash"></i>
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           <div className="row mt-4">
//             <div className="col-lg-6 col-md-6 col-sm-12">
//               <label className="form-label">
//                 <b>Notes :</b>
//                 <br />
//                 <textarea
//                   className="form-control notes-textarea"
//                   type="text"
//                   value={getData.notes || ""}
//                   onChange={(e) => {
//                     setData({ ...getData, notes: e.target.value });
//                   }}
//                   required
//                 />
//               </label>
//             </div>
//             <div className="col-lg-6 col-md-6 col-sm-12">
//               <form>
//                 <div className="row">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Sub Total</b>
//                     </label>
//                   </div>
//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${subtotal.toFixed(2)}`
//                           : `${subtotal.toFixed(2)}`
//                       }
//                       type="text"
//                       placeholder="Sub Total"
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="row mt-3">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Paypal Tax</b>
//                     </label>
//                   </div>
//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${tax.toFixed(2)}`
//                           : `${tax.toFixed(2)}`
//                       }
//                       type="text"
//                       placeholder="Tax"
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="row mt-3">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Net Total</b>
//                     </label>
//                   </div>
//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${Math.round(storedNetTotal).toFixed(2)}`
//                           : `${Math.round(storedNetTotal).toFixed(2)}`
//                       }
//                       type="text"
//                       placeholder="Net Total"
//                       readOnly
//                     />
//                   </div>
//                 </div>
//               </form>
//             </div>
//           </div>

//           <div className="row">
//             <div className="col-lg-5"></div>
//             <div className="col-lg-7">
//               <div
//                 style={{ marginLeft: "75px" }}
//                 className="d-flex justify-content-evenly mt-3 buttonstyle"
//               >
//                 <button
//                   type="button"
//                   className="btn btn-danger invoice-button"
//                   onClick={handleClearAll}
//                 >
//                   Clear
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-info text-white invoice-button"
//                   style={{ backgroundColor: "#007BFF" }}
//                   onClick={handleback}
//                 >
//                   Back
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-success invoice-button"
//                   onClick={submitdata}
//                 >
//                   Update
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-secondary invoice-button"
//                   onClick={handlenavigate}
//                 >
//                   Print
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default InvoiceUpdate;

import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import apiUrl from "../../Environment/Api";
import { useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const useForceUpdate = () => {
  const [, forceUpdate] = useState();
  return useCallback(() => forceUpdate((prev) => !prev), []);
};

function InvoiceUpdate() {
  const forceUpdate = useForceUpdate();
  const navigate = useNavigate();
  const [exchangeRate, setExchangeRate] = useState("");

  const { invoice_id } = useParams();
  console.log("edit id", invoice_id);

  const [invoiceData, setInvoiceDetails] = useState({});
  const [getclientaddress, setclientaddress] = useState("");
  const [getclientcountry, setclientcountry] = useState("");
  const [getclientmobile, setclientmobile] = useState("");
  const [getclientName, setclientName] = useState("");
  const [selectedClient, setSelectedClient] = useState("");
  const [invoicedetailsId, setinvoicedetailsId] = useState("");

  // State for dynamic columns - changed to array like Invoiceadd
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [columnNames, setColumnNames] = useState({
    standard: "Standard",
    premier: "Premier",
    twilight: "Twilight",
    day_to_dusk: "Day to Dusk",
    vra: "VRA(5$)",
    vr: "VR(12$)",
    col7: "Column 7",
    col8: "Column 8",
    col9: "Column 9",
    col10: "Column 10",
    col11: "Column 11",
    col12: "Column 12"
  });

  // Modal state (like in Invoiceadd)
  const [showModal, setShowModal] = useState(false);
  const [pendingColumnKey, setPendingColumnKey] = useState(null);
  const [modalColumnName, setModalColumnName] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);

  // Column order - all columns in sequence
  const columnOrder = ['standard', 'premier', 'twilight', 'day_to_dusk', 'vra', 'vr', 'col7', 'col8', 'col9', 'col10', 'col11', 'col12'];

  // Function to add a new column - opens modal
  const handleAddColumn = () => {
    const availableColumns = columnOrder.filter(col => !visibleColumns.includes(col));
    if (availableColumns.length > 0) {
      const nextColumnKey = availableColumns[0];
      setPendingColumnKey(nextColumnKey);
      setModalColumnName(columnNames[nextColumnKey]);
      setIsEditMode(false);
      setShowModal(true);
    }
  };

  // Function to edit existing column name - opens modal
  const handleEditColumn = (columnKey) => {
    setPendingColumnKey(columnKey);
    setModalColumnName(columnNames[columnKey]);
    setIsEditMode(true);
    setShowModal(true);
  };

  // Function to remove a column
  const handleRemoveColumn = (columnKey) => {
    if (window.confirm(`Are you sure you want to remove the "${columnNames[columnKey]}" column? This will clear all data in this column.`)) {
      // Remove from visible columns
      setVisibleColumns(visibleColumns.filter(col => col !== columnKey));

      // Clear data from all rows for this column
      const updatedTableData = tableData.map(row => ({
        ...row,
        [columnKey]: ""
      }));
      setTableData(updatedTableData);
    }
  };

  // Handle modal save
  const handleModalSave = () => {
    if (modalColumnName.trim() !== "" && pendingColumnKey) {
      // Update column name
      setColumnNames({
        ...columnNames,
        [pendingColumnKey]: modalColumnName
      });

      // Only add to visible columns if we're adding a new column
      if (!isEditMode) {
        setVisibleColumns([...visibleColumns, pendingColumnKey]);
      }

      // Close modal
      setShowModal(false);
      setModalColumnName("");
      setPendingColumnKey(null);
      setIsEditMode(false);
    } else {
      alert("Please enter a column name");
    }
  };

  // Handle modal cancel
  const handleModalCancel = () => {
    setShowModal(false);
    setModalColumnName("");
    setPendingColumnKey(null);
    setIsEditMode(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const responseDetails = await axios.get(
          apiUrl + `/invoicedetails/${invoice_id}`
        );
        const invoiceDetails = responseDetails.data[0];
        setInvoiceDetails(invoiceDetails);
        setSelectedClient(invoiceDetails.clientId);
        setinvoicedetailsId(invoiceDetails.id);
        setData({
          invoiceId: invoiceDetails.invoiceId,
          date: invoiceDetails.date,
          dueDate: invoiceDetails.dueDate,
          notes: invoiceDetails.notes,
          totalTax: invoiceDetails.totalTax,
          paymentStatus: invoiceDetails.paymentStatus,
          totalAmount: invoiceDetails.totalAmount,
          paymentDate: invoiceDetails.paymentDate,
        });

        // **NEW: Load column configuration**
        try {
          const columnResponse = await axios.get(
            apiUrl + `/invoice-columns/${invoice_id}`
          );

          if (columnResponse.data.status === 'success' && columnResponse.data.data) {
            const savedColumns = columnResponse.data.data;

            // Update column names with saved values
            setColumnNames({
              standard: savedColumns.standard || "Standard",
              premier: savedColumns.premier || "Premier",
              twilight: savedColumns.twilight || "Twilight",
              day_to_dusk: savedColumns.day_to_dusk || "Day to Dusk",
              vra: savedColumns.vra || "VRA(5$)",
              vr: savedColumns.vr || "VR(12$)",
              col7: savedColumns.col7 || "Column 7",
              col8: savedColumns.col8 || "Column 8",
              col9: savedColumns.col9 || "Column 9",
              col10: savedColumns.col10 || "Column 10",
              col11: savedColumns.col11 || "Column 11",
              col12: savedColumns.col12 || "Column 12"
            });
          }
        } catch (err) {
          console.error("Error loading column configuration:", err);
        }

        const responseList = await axios.get(
          apiUrl + `/invoicelist/${invoice_id}`
        );

        // **FIXED: Properly load price, tax, amount, rate**
        const formattedData = responseList.data.map((item) => ({
          ...item,
          quantity: item.quantity || 1,
          price: item.price || 0,
          tax: item.tax || 0,
          amount: item.amount || "",
          rate: item.rate || "",
          standard: item.standard || "",
          premier: item.premier || "",
          twilight: item.twilight || "",
          day_to_dusk: item.day_to_dusk || "",
          vra: item.vra || "",
          vr: item.vr || "",
          col7: item.col7 || "",
          col8: item.col8 || "",
          col9: item.col9 || "",
          col10: item.col10 || "",
          col11: item.col11 || "",
          col12: item.col12 || "",
        }));
        setTableData(formattedData);

        // Determine visible columns
        const allColumns = ['standard', 'premier', 'twilight', 'day_to_dusk', 'vra', 'vr', 'col7', 'col8', 'col9', 'col10', 'col11', 'col12'];
        const visibleCols = [];

        allColumns.forEach((col) => {
          const hasData = formattedData.some(item =>
            item[col] && item[col].toString().trim() !== '' && parseFloat(item[col] || 0) !== 0
          );
          if (hasData) {
            visibleCols.push(col);
          }
        });

        setVisibleColumns(visibleCols);

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [invoice_id]);

  const [ClientDetails, setClientDetails] = useState([]);
  const clientdetails = async () => {
    try {
      const response = await axios.get(apiUrl + "/clientdetails");
      if (response) setClientDetails(response.data);
    } catch (error) {
      console.error("Error fetching client details:", error);
    }
  };

  useEffect(() => {
    clientdetails();
    categorytype();

    const fetchExchangeRate = async () => {
      try {
        const response = await fetch(
          "https://api.frankfurter.app/latest?from=USD&to=INR"
        );
        const data = await response.json();
        setExchangeRate(data.rates.INR || 83);
      } catch (error) {
        setExchangeRate(83);
      }
    };
    fetchExchangeRate();
  }, []);

  const [currentDate] = useState(getFormattedDate());
  const [tableData, setTableData] = useState([]);
  const [subtotal, setSubtotal] = useState(0);
  const [tax, setTax] = useState(0);
  const [netTotal, setNetTotal] = useState(0);
  const [clientRowCreated, setClientRowCreated] = useState(false);
  const [storedNetTotal, setStoredNetTotal] = useState(0);

  function filter() {
    const client = ClientDetails.find((data) => data.id === selectedClient);
    if (client) {
      setclientName(client.clientName);
      setclientaddress(client.address);
      setclientcountry(client.countrycode);
      setclientmobile(client.mobile);
    }
  }

  useEffect(() => {
    if (ClientDetails.length > 0 && selectedClient) filter();
  }, [ClientDetails, selectedClient]);

  const handlerowadd = (e) => {
    e.preventDefault();
    const newId = Date.now();
    const newRow = {
      id: newId,
      date: getFormattedDate(),
      projectName: "",
      standard: "",
      premier: "",
      twilight: "",
      day_to_dusk: "",
      vra: "",
      vr: "",
      col7: "",
      col8: "",
      col9: "",
      col10: "",
      col11: "",
      col12: "",
      type: "",
      quantity: 1,
      price: 0,
      tax: "",
      amount: "",
      rate: "",
    };
    setTableData((prev) => [...prev, newRow]);
    setClientRowCreated(true);
  };

  const handleTypeChange = (index, value) => {
    if (!value) return;
    setTableData((prev) => {
      const updated = [...prev];
      updated[index].type = value;

      const cat = getCategoryType.find((item) => item.type === value);
      if (cat) {
        updated[index].price =
          getclientcountry === "91" ? cat.INRprice : cat.price;
      }
      return updated;
    });
  };

  const handleUserInputChange = (index, property, value) => {
    console.log("handleUserInputChange triggered:", index, property, value);
    setTableData((prev) => {
      const updated = [...prev];
      updated[index][property] = value;
      return updated;
    });
  };

  useEffect(() => {
    let sub = 0,
      tx = 0;
    tableData.forEach((item) => {
      const qty = parseFloat(item.quantity) || 1;
      const price = parseFloat(item.price) || 0;
      const taxRate = parseFloat(item.tax) || 0;
      const lineTotal = qty * price;
      sub += lineTotal;
      tx += (lineTotal * taxRate) / 100;
    });
    setSubtotal(sub);
    setTax(tx);
    setNetTotal(sub + tx);
  }, [tableData]);

  useEffect(() => {
    let finalAmount = 0;

    if (getclientcountry === "91") {
      finalAmount = netTotal * exchangeRate;
    } else {
      finalAmount = netTotal;
    }

    setStoredNetTotal(finalAmount);
  }, [netTotal, getclientcountry, exchangeRate]);

  const [deleteids, setDeleteIds] = useState([]);
  const tablerowdelete = (id) => {
    setTableData((prev) => prev.filter((item) => item.id !== id));
    if (typeof id === "number" && id < 1000000) {
      setDeleteIds((prev) => [...prev, id]);
    }
  };

  const handleClearAll = () => {
    setTableData([]);
    setClientRowCreated(false);
  };

  const handleback = () => navigate("/invoice");

  const [getCategoryType, setCategoryType] = useState([]);
  const categorytype = async () => {
    try {
      const response = await axios.get(apiUrl + "/category");
      setCategoryType(response.data || []);
    } catch (err) {
      console.log(err);
    }
  };

  function getFormattedDate() {
    const today = new Date();
    const year = today.getFullYear();
    let month = today.getMonth() + 1;
    let day = today.getDate();
    month = month < 10 ? `0${month}` : month;
    day = day < 10 ? `0${day}` : day;
    return `${year}-${month}-${day}`;
  }

  const validateForm = () => {
    const empty = [];
    if (!selectedClient) empty.push("Client Name");
    if (!getData.date) empty.push("Date");
    if (!getData.dueDate) empty.push("Due Date");

    // tableData.forEach((item, i) => {
    //   // Check for projectName instead of type
    //   if (item.projectName && item.projectName.trim() !== "") {
    //     if (!item.tax || item.tax === "") empty.push(`Tax at row ${i + 1}`);
    //     if (!item.quantity || item.quantity === "") empty.push(`Quantity at row ${i + 1}`);
    //     if (!item.price || item.price === "") empty.push(`Price at row ${i + 1}`);
    //   }
    // });

    if (empty.length > 0) {
      toast(`Please fill: ${empty.join(", ")}`);
      return false;
    }
    return true;
  };

  const [isDataSubmitted, setIsDataSubmitted] = useState(false);
  const [getData, setData] = useState({
    invoiceId: "",
    clientName: "",
    date: "",
    dueDate: "",
    notes: "",
    totalTax: "",
    paymentStatus: "Unpaid",
    totalAmount: "",
    paymentDate: "",
  });

  const toaster = (cb) =>
    toast.success("Updated successfully!", { autoClose: 1000, onClose: cb });

  const submitdata = async () => {
    if (isDataSubmitted || !validateForm()) return;
    setIsDataSubmitted(true);

    try {
      const filtered = tableData;

      const mainUpdate = {
        invoiceId: invoice_id,
        clientName: selectedClient,
        date: getData.date,
        dueDate: getData.dueDate,
        totalAmount: netTotal.toFixed(2),
        notes: getData.notes,
        totalTax: tax.toFixed(2),
        paymentStatus: "Unpaid",
        paymentDate: "",
      };

      await axios.put(`${apiUrl}/invoicedetailsupdate/${invoicedetailsId}`, {
        ...getData,
        ...mainUpdate,
      });

      // Update column configuration
      const columnConfig = {
        clientName: selectedClient,
        ...columnNames
      };

      try {
        await axios.put(apiUrl + `/invoice-columns/${invoice_id}`, columnConfig);
        console.log("Column configuration updated");
      } catch (err) {
        console.error("Error updating column configuration:", err);
      }

      // Delete removed rows
      for (const id of deleteids) {
        await axios.delete(`${apiUrl}/invoicelist/${id}`);
      }
      setDeleteIds([]);

      // **MISSING CODE - Prepare list data**
      const listData = filtered.map((data) => {
        const qty = parseFloat(data.quantity) || 1;
        const price = parseFloat(data.price) || 0;
        const taxRate = parseFloat(data.tax) || 0;

        const rateUSD = (price * (1 + taxRate / 100)).toFixed(2);
        const amountINR = (price * exchangeRate * (1 + taxRate / 100)).toFixed(2);
        const totalAmt = (qty * price * (1 + taxRate / 100)).toFixed(2);

        const isNewRow = data.id > 100000000000;

        const rowData = {
          invoiceId: invoice_id,
          date: data.date || getFormattedDate(),
          clientName: selectedClient,
          projectName: data.projectName || "",
          standard: data.standard || "",
          premier: data.premier || "",
          twilight: data.twilight || "",
          day_to_dusk: data.day_to_dusk || "",
          vra: data.vra || "",
          vr: data.vr || "",
          col7: data.col7 || "",
          col8: data.col8 || "",
          col9: data.col9 || "",
          col10: data.col10 || "",
          col11: data.col11 || "",
          col12: data.col12 || "",
          type: data.type || "",
          quantity: qty,
          price: price.toString(),
          tax: taxRate.toString(),
          amount: data.amount || amountINR,
          rate: data.rate || rateUSD,
          totalAmount: totalAmt,
        };

        // Don't include id for new rows
        if (!isNewRow) {
          rowData.id = data.id;
        }

        return rowData;
      });

      console.log("DATA BEING SENT TO BACKEND:", JSON.stringify(listData, null, 2));

      // **MISSING CODE - Send the invoice list data**
      await axios.post(apiUrl + "/invoicelistupdate", listData);

      toaster(() => navigate("/invoice"));
    } catch (err) {
      console.error(err);
      toast.error("Update failed");
      setIsDataSubmitted(false);
    }
  };

  const handlenavigate = async () => {
    const isValid = validateForm();
    if (isValid) {
      try {
        await submitdata();
        // Small delay to ensure data is saved
        setTimeout(() => {
          navigate(`/invoice/invoiceprint/${invoice_id}`);
        }, 1000);
      } catch (error) {
        console.error("Error submitting data and navigating:", error);
      }
    }
  };

  return (
    <>
      <ToastContainer />

      {/* Modal for naming/editing columns (from Invoiceadd) */}
      {showModal && (
        <div
          className="modal fade show"
          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {isEditMode ? 'Edit Column Name' : 'Name Your Column'}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleModalCancel}
                ></button>
              </div>
              <div className="modal-body">
                <label className="form-label">Column Name:</label>
                <input
                  type="text"
                  className="form-control"
                  value={modalColumnName}
                  onChange={(e) => setModalColumnName(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      handleModalSave();
                    }
                  }}
                  placeholder="Enter column name"
                  autoFocus
                />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleModalCancel}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleModalSave}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <h3 className="text-center">Edit Invoice</h3>
      <hr />
      <div className="mx-1">
        <div className="invoicebackground1">
          <form className="row">
            <div className="col-lg-3 col-md-4 col-sm-12">
              <label className="form-label">Invoice No.</label>
              <input
                className="form-control"
                value={invoice_id}
                type="text"
                readOnly
              ></input>
            </div>
            <div className="col-lg-6 col-md-4"></div>
            <div className="col-lg-3 col-md-4 col-sm-12">
              <label className="form-label">Date :</label>
              <input
                className="form-control"
                type="date"
                value={getData.date || ""}
                onChange={(e) => setData({ ...getData, date: e.target.value })}
                required
              />
            </div>
          </form>
        </div>

        <div className="invoicebackground1">
          <form className="row">
            <div className="col-lg-3 col-md-4 col-sm-12">
              <div className="dropdown">
                <label className="form-label">Client Name :</label>
                <div className="position-relative">
                  <select
                    className="form-control dropdown-toggle custom-select"
                    value={selectedClient}
                    disabled
                  >
                    <option value="">{getclientName}</option>
                  </select>
                  <div className="dropdown-arrow"></div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-4">
              <div className="mt-4">
                {/* Add Row Button */}
                <button
                  type="button"
                  className="btn btn-success btn-sm mt-2 me-2"
                  onClick={handlerowadd}
                >
                  <i className="fa-solid fa-plus me-1"></i>
                  Add Row
                </button>
                {/* Add Column Button */}
                {visibleColumns.length < 12 && (
                  <button
                    type="button"
                    className="btn btn-primary btn-sm mt-2"
                    onClick={handleAddColumn}
                  >
                    <i className="fa-solid fa-plus me-1"></i>
                    Add Column
                  </button>
                )}
              </div>
            </div>
            <div className="col-lg-3"></div>
            <div className="col-lg-3 col-md-4 col-sm-12">
              <form className="control">
                <label className="form-label">Due Date</label>
                <input
                  className="form-control"
                  value={getData.dueDate || ""}
                  type="date"
                  onChange={(e) =>
                    setData({ ...getData, dueDate: e.target.value })
                  }
                  required
                />
              </form>
            </div>
          </form>
        </div>

        <div className="invoicebackground1">
          {/* **FIXED: Added wrapper with fixed width and horizontal scroll** */}
          <div style={{ width: '100%', overflowX: 'auto' }}>
            <table className="table table-bordered" style={{ minWidth: '1400px', tableLayout: 'fixed' }}>
              <thead className="font-size">
                <tr>
                  <th style={{ width: "50px" }}>S.No</th>
                  <th style={{ width: "120px" }}>Date</th>
                  <th style={{ width: "150px" }}>Address</th>

                  {/* Dynamic columns - ALL columns after Address are now dynamic */}
                  {visibleColumns.map((colKey) => (
                    <th key={colKey} style={{ width: "70px" }}>
                      <div
                        className="d-flex align-items-center justify-content-between"
                        style={{ gap: '5px', overflow: 'hidden' }}
                      >
                        <span
                          style={{ 
                            cursor: 'pointer', 
                            flex: 1,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                          }}
                          onClick={() => handleEditColumn(colKey)}
                          title={columnNames[colKey]}
                        >
                          {columnNames[colKey]}
                        </span>
                        <i
                          className="fa-solid fa-edit"
                          style={{ fontSize: '12px', cursor: 'pointer', flexShrink: 0 }}
                          onClick={() => handleEditColumn(colKey)}
                          title="Edit column name"
                        ></i>
                        <i
                          className="fa-solid fa-trash text-danger"
                          style={{ fontSize: '12px', cursor: 'pointer', flexShrink: 0 }}
                          onClick={() => handleRemoveColumn(colKey)}
                          title="Remove column"
                        ></i>
                      </div>
                    </th>
                  ))}

                  <th style={{ width: "70px" }}>$ Price</th>
                  <th style={{ width: "70px" }}>Tax</th>
                  <th style={{ width: "88px" }}>₹ Amount</th>
                  <th style={{ width: "75px" }}>$ Rate</th>
                  <th style={{ width: "60px" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((item, index) => {
                  // **FIXED: Calculate amount and rate based on current values**
                  const currentPrice = parseFloat(item.price) || 0;
                  const currentTax = parseFloat(item.tax) || 0;
                  const calculatedAmount = (currentPrice * exchangeRate * (1 + currentTax / 100)).toFixed(2);
                  const calculatedRate = (currentPrice * (1 + currentTax / 100)).toFixed(2);

                  return (
                    <tr key={item.id}>
                      <th scope="row">{index + 1}</th>
                      <td>
                        <input
                          style={{ width: "100%" }}
                          className="form-control pe-0"
                          type="date"
                          value={item.date || ""}
                          onChange={(e) =>
                            handleUserInputChange(index, "date", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <input
                          style={{ width: "100%" }}
                          className="form-control"
                          type="text"
                          value={item.projectName || ""}
                          onChange={(e) =>
                            handleUserInputChange(
                              index,
                              "projectName",
                              e.target.value
                            )
                          }
                        />
                      </td>

                      {/* Dynamic column inputs - render based on visible columns */}
                      {visibleColumns.map((colKey) => (
                        <td key={colKey}>
                          <input
                            className="form-control"
                            type="text"
                            value={item[colKey] || ""}
                            onChange={(e) =>
                              handleUserInputChange(index, colKey, e.target.value)
                            }
                          />
                        </td>
                      ))}

                      <td>
                        <input
                          className="form-control"
                          type="tel"
                          value={item.price || ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            const onlyNumbers = value.replace(/[^0-9]/g, "");
                            handleUserInputChange(index, "price", onlyNumbers);
                          }}
                        />
                      </td>

                      <td>
                        <input
                          className="form-control"
                          type="tel"
                          value={item.tax || ""}
                          placeholder="Tax"
                          onChange={(e) => {
                            const value = e.target.value;
                            const onlyNumbers = value.replace(/[^0-9]/g, "");
                            handleUserInputChange(index, "tax", onlyNumbers);
                          }}
                        />
                      </td>

                      <td>
                        <input
                          type="text"
                          className="form-control ps-2"
                          value={calculatedAmount}
                          onChange={(e) => {
                            const value = e.target.value.replace(/[^0-9.]/g, "");
                            handleUserInputChange(index, "amount", value);
                          }}
                        />
                      </td>

                      <td>
                        <input
                          className="form-control ps-2"
                          placeholder="rate"
                          value={calculatedRate}
                          onChange={(e) => {
                            const value = e.target.value.replace(/[^0-9.]/g, "");
                            handleUserInputChange(index, "rate", value);
                          }}
                        />
                      </td>

                      <td>
                        <button
                          className="btn btn-danger px-1 py-1 d-flex align-items-center"
                          onClick={() => tablerowdelete(item.id)}
                        >
                          <i className="fa-solid fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div className="row mt-4">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <label className="form-label">
                <b>Notes :</b>
                <br />
                <textarea
                  className="form-control notes-textarea"
                  type="text"
                  value={getData.notes || ""}
                  onChange={(e) => {
                    setData({ ...getData, notes: e.target.value });
                  }}
                  required
                />
              </label>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <form>
                <div className="row">
                  <div className="col-lg-5 col-md-6 mt-1">
                    <label className="form-label">
                      <b>Sub Total</b>
                    </label>
                  </div>
                  <div className="col-lg-7 col-md-6">
                    <input
                      className="form-control"
                      value={
                        getclientcountry === "91"
                          ? `₹${subtotal.toFixed(2)}`
                          : `${subtotal.toFixed(2)}`
                      }
                      type="text"
                      placeholder="Sub Total"
                      readOnly
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg-5 col-md-6 mt-1">
                    <label className="form-label">
                      <b>Paypal Tax</b>
                    </label>
                  </div>
                  <div className="col-lg-7 col-md-6">
                    <input
                      className="form-control"
                      value={
                        getclientcountry === "91"
                          ? `₹${tax.toFixed(2)}`
                          : `${tax.toFixed(2)}`
                      }
                      type="text"
                      placeholder="Tax"
                      readOnly
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg-5 col-md-6 mt-1">
                    <label className="form-label">
                      <b>Net Total</b>
                    </label>
                  </div>
                  <div className="col-lg-7 col-md-6">
                    <input
                      className="form-control"
                      value={
                        getclientcountry === "91"
                          ? `₹${Math.round(storedNetTotal).toFixed(2)}`
                          : `${Math.round(storedNetTotal).toFixed(2)}`
                      }
                      type="text"
                      placeholder="Net Total"
                      readOnly
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-5"></div>
            <div className="col-lg-7">
              <div
                style={{ marginLeft: "75px" }}
                className="d-flex justify-content-evenly mt-3 buttonstyle"
              >
                <button
                  type="button"
                  className="btn btn-danger invoice-button"
                  onClick={handleClearAll}
                >
                  Clear
                </button>
                <button
                  type="button"
                  className="btn btn-info text-white invoice-button"
                  style={{ backgroundColor: "#007BFF" }}
                  onClick={handleback}
                >
                  Back
                </button>
                <button
                  type="button"
                  className="btn btn-success invoice-button"
                  onClick={submitdata}
                >
                  Update
                </button>
                <button
                  type="button"
                  className="btn btn-secondary invoice-button"
                  onClick={handlenavigate}
                >
                  Print
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default InvoiceUpdate;